{
  "LOGIN": {
        "SSO-BUTTON": "Prihlásiť sa cez SSO",
    "APP-NAME": "Platform {{ appName }}",
    "TITLE": "Prihláste sa do editora Workflow",
    "ACCOUNT-PLACEHOLDER": "Názov účtu",
    "ACCOUNT-REQUIRED": "Vyžaduje sa názov účtu.",
    "ACCOUNT-SHORT": "Názov účtu musí pozostávať aspoň z 2 znakov.",
    "USERNAME-PLACEHOLDER": "Používateľské meno",
    "USERNAME-REQUIRED": "Vyžaduje sa používateľské meno.",
    "USERNAME-SHORT": "Používateľské meno musí pozostávať aspoň z 2 znakov.",
    "PASSWORD-PLACEHOLDER": "Heslo",
    "PASSWORD-REQUIRED": "Vyžaduje sa heslo.",
    "PASSWORD-SHORT": "Heslo musí pozostávať aspoň zo 6 znakov.",
    "REMEMBER-ACCOUNT-NAME": "Zapamätať si názov účtu",
    "FORGOT-PASSWORD": "ZABUDNUTÉ HESLO?",
    "LOGIN-BUTTON": "PRIHLÁSIŤ SA",
    "BACK": "SPÄŤ",
    "VERIFICATION-CODE": "Overovací kód",
    "VERIFICATION-SENDED": "Poslali sme vám e-mail s overovacím kódom.",
    "VERIFY-BUTTON": "VERIFY.",
    "TERMS": "Podmienky služby",
    "PRIVACY": "Zásady ochrany osobných údajov",
    "NO-INTERNET-ERROR": "Žiadny internet. Skontrolujte svoje internetové pripojenie.",
    "USERNAME-PASSWORD-ERROR": "Používateľské meno alebo heslo je nesprávne.",
    "INVALID-VERIFICATION-CODE": "Neplatný dvojstupňový overovací kód.",
    "ACCOUNT-DISABLED": "Platnosť vášho účtu vypršala. Kontaktujte prosím {{ contactMail }}",
    "NO-WORKFLOW-LICENSE": "Žiadna licencia na pracovný postup. Kontaktujte prosím {{ contactMail }}",
    "UNKNOWN-ERROR": "Pri prihlasovaní sa vyskytla chyba.",
    "LINK-ID-MISSING": "Chýba ID odkazu",
    "INTERNAL-ERROR": "Neznáma chyba",
    "ID-OR-NAME-MISSING": "Chýba ID alebo názov odkazu",
    "GUEST-PASSWORD-WRONG": "Heslo pracovného postupu je nesprávne"
  },
  "MAIN": {
    "CONTENT": {
      "DASHBOARD": {
        "NO-WORKFLOW-FOR-NORMAL-USERS": "Prázdny zoznam",
        "NO-WORKFLOW": {
          "TITLE": "Workflow",
          "TEXT": "Chceli by ste vedieť, ako si zjednodušiť pracovné procesy, eliminovať papierovanie a zredukovať administratívne úkony? Naše softvérové riešenie je jednotné softvérové riešenie pre riadenie pracovných procesov, ktoré zníži zložitosť riadenia ľudských zdrojov a pracovných procesov. Toto softvérové riešenie je možné prispôsobiť vašim špecifickým potrebám a ide o škálovateľnú technológiu.",
          "CREATE": "Vytvoriť pracovný postup"
        },
        "AI-IN-PROGRESS": "AI prebieha...",
        "TITLE": "Pracovné postupy",
        "CREATE": "VYTVORTE PRACOVNÝ POSTUP",
        "GENERATE": "VYTVORTE AUTOMATICKÝ PRACOVNÝ POSTUP POMOCOU AI",
        "WORKFLOW-TABLE": {
          "NAME": "Názov",
          "CREATED-BY": "Vytvoril",
          "STATUS": {
            "TITLE": "Status",
            "PUBLISHED": "Publikovaný",
            "DRAFT": "Návrh",
            "INCOMPLETE": "Neúplné"
          },
          "ACTIONS": {
            "TITLE": "Akcie",
            "OPTIONS": {
              "TITLE": "možnosti",
              "EDIT": "Upraviť koncept",
              "USERS": "Používatelia",
              "PUBLISH": "Zverejniť koncept",
              "PUBLISH-VIEW": "Zobraziť Zverejnené",
              "DUPLICATE": "Doplikovať pracovný postup",
              "DELETE": "Odstrániť pracovný postup",
              "MOVE-TO-FOLDER": "Premiestni do priečinku"
            },
            "PREFILLED-OPTIONS": {
              "EDIT": "Upraviť",
              "SHOW-QR": "Zobraziť QR",
              "DUPLICATE": "Duplicitné",
              "DELETE": "Odstrániť"
          },
          "SUBMITTED-OPTIONS": {
            "SHOW-REPORT": "Pozrieť si správu",
            "CHANGE-PREFILLED": "Zmeňte na predvyplnené"
          }
          },
          "START": "ŠTART",
          "LAST-EDITED": "Naposledy upravené",
          "PUBLISHED-AT": "Zverejnené o",
          "LANGUAGES": "Jazyky",
          "CONTENT-LANGUAGE": "JAZYK OBSAHU",
          "FILTER": {
            "FILTER-BY": "Triediť podľa",
            "SELECT-LABEL": "Vyberte štítok",
            "SELECTED-LABELS": "Vybrané štítky"
          },
          "MANAGE-WORKFLOWS": "Spravujte pracovné postupy"
        },
        "FOLDER": {
          "MOVE-TO-FOLDER": "Premiestni do priečinku",
          "SELECTED": "vybraný",
          "CREATE-FOLDER": "VYTVORIŤ NOVÝ PRIESTOR",
          "NOT-FOLDERED": "Nie je v priečinkoch",
          "DELETE-FOLDER": "Odstrániť priečinok",
          "NO-WORKFLOW-FOUND": "Nenašli sa žiadne pracovné postupy.",
          "EDIT-FOLDER": "Upraviť priečinok",
          "MOVE-TO": "Presunúť do",
          "FOLDER-NAME": "Názov priečinka",
          "CREATE": "Vytvorte",
          "FOLDERS": "Priečinky",
          "FOLDER-NAME-UNIQUE-ERROR": "Názov priečinka musí byť jedinečný",
          "DELETE-FOLDER-WARNING-TEXT": "Naozaj chcete odstrániť priečinok?",
          "DELETE-FOLDER-INFO-TEXT": "Odstránením tohto priečinka sa neodstránia obsiahnuté pracovné postupy; budú presunuté do priečinka Nepriečinok"
      },
        "SEARCH": {
          "TITLE": "Pokročilé vyhľadávanie",
          "PLACEHOLDER": "Zadajte vyhľadávací dopyt...",
          "BUTTON": "Hľadať",
          "CANCEL": "Zrušiť",
          "CLEAR": "Vymazať vyhľadávanie",
          "RESULTS": "Výsledky vyhľadávania",
          "NO_RESULTS": "Pre váš vyhľadávací dopyt sa nenašli žiadne pracovné postupy.",
          "ERROR": "Vyhľadávanie zlyhalo. Skúste to znova.",
          "APPLIED": "Vyhľadávanie použité"
        },
        "TEXT-MESSAGE": "Vaše zmeny budú odstránené. Chcete odstrániť tento pracovný postup, ktorý ste predtým pridali?",
        "TEXT-MESSAGE-PUBLISH-VIEW": "Prepnete sa do režimu úprav. Môžete vykonať zmeny na poslednom aktualizovanom koncepte.",
        "TEXT-MESSAGE-UNSAVED-CHANGES": "Existujú neuložené zmeny. Budú uložené a zverejnené.",
        "TEXT-MESSAGE-CLOSE-WORKFLOW": "Naozaj chcete zatvoriť tento pracovný postup? Vaše zmeny budú odstránené.",
        "TEXT-MESSAGE-CONDITIONAL-WORKFLOW": "Pracovný postup, ktorý sa pokúšate otvoriť, je pracovný postup s podmienkami. Naša webová verzia to zatiaľ nepodporuje.",
        "CANCEL": "ZRUŠIŤ",
        "CLOSE": "ZAVRIEŤ",
        "EXPORT-WORKFLOWS": "EXPORTOVAŤ PRACOVNÉ POSTUPY",
        "SAVE-AS-DRAFT": "Uložiť ako koncept",
        "CONTINUE": "Pokračovať",
        "UPDATE": "Aktualizovať",
        "CONTINUE-UPPERCASE": "POKRAČOVAŤ",
        "START-OVER": "ZAČAŤ ODZNOVA",
        "WORKFLOW-STARTED": "Tento pracovný postup ste už začali. Chcete pokračovať, alebo začať nový?",
        "NEW-VERSION": "Tento pracovný postup nie je možné otvoriť. Musíte zverejniť novú verziu pracovného postupu",
        "ANOTHER-COPY": "Kópia tohto pracovného postupu sa vytvorí ako verzia 1 v stave konceptu s príponou \"(Copy)\" v názve. Skopírujú sa aj všetky jeho kroky, polia a súbory.",
        "DUPLICATE-SUCCESSFUL": "Workflow bol úspešne skopírovaný.",
        "DUPLICATE-NESTED-SKIPPED": "Odkazy na vnorené workflow neboli skopírované.",
        "DUPLICATE-FILES-FAILED": "Nepodarilo sa skopírovať {{count}} súbor(ov). Kópia stále odkazuje na pôvodné súbory.",
        "DUPLICATE-PARTIAL": "Kópia bola vytvorená, ale kopírovanie súborov sa nedokončilo. Otvorte kópiu a skontrolujte médiá.",
        "DUPLICATE-ERROR": "Tento workflow sa nedá skopírovať.",
        "DELETE-SUCCESSFUL": "Operácia odstránenia bola úspešná",
        "DELETE-ERROR": "Chyba vymazania",
        "WORKFLOW-NOT-FOUND": "Pracovný postup sa nenašiel",
        "CREATION-LIMIT": "Bol dosiahnutý limit vytvárania pracovného postupu",
        "PUBLISH-SUCCESSFUL": "Publikovanie je úspešné",
        "PUBLISH-ERROR": "Chyba zverejnenia",
        "EXPORT-CANCELED": "Export bol zrušený",
        "EXPORT-FOLDER": "Exportný priečinok existuje",
        "EXPORT-SUCCESSFUL": "Export je úspešný",
        "YES": "ÁNO",
        "DELETE-REPORT-TITLE": "Odstrániť prehľad",
        "DELETE-REPORT-TEXT": "Naozaj chcete odstrániť tento prehľad?",
        "CONNECTED-WORKFLOW-WARNING-TEXT": "Tento pracovný postup nemožno odstrániť, pretože je pripojený k inému pracovnému postupu. Najprv ho musíte odstrániť z pripojeného pracovného postupu.",
        "SUBMITTED-REPORT-TO-PREFILLED-TEXT": "Naozaj chcete zmeniť tento prehľad ako predvyplnený?",
        "SUBMITTED-REPORT-TO-PREFILLED-TITLE": "Zmeniť stav prehľadu",
        "NESTED-WORKFLOWS-CONNECTION-ENABLE-WARNING": "V pracovnom postupe, ktorý ste pridali, je spojenie. Preto bude pripojenie aktivované vo vašom aktuálnom pracovnom postupe. Po uložení pracovného postupu skontrolujte stránku pripojení."
      },
      "REMOTE": {
        "IMAGE-COLLABORATION": {
          "UNDO": "Vrátiť späť",
          "REDO": "Znovu",
          "ANNOTATE": "Komentovať",
          "REVERT": "Prejsť späť",
          "ZOOM-IN": "Priblížiť",
          "ZOOM-OUT": "Oddialiť",
          "UP": "Hore",
          "DOWN": "Dole",
          "LEFT": "Vľavo",
          "RIGHT": "Vpravo"
        }
      },
      "REPORT": {
        "NAME": "Nźov",
        "DESCRIPTION": "Popis",
        "STEPS-COMPLETED": "Dokončené kroky",
        "START": "Začaté o",
        "END": "Ukončené o",
        "DURATION": "Trvanie",
        "EXPORT": "Export as CSV",
        "SUBMITTED-BY": "Predložil",
        "STEP-LIST": {
          "NAME": "Názov úlohy",
          "CONTENT": "Obsah",
          "DURATION": "Trvanie",
          "NO-CONTENT": "N/A",
          "DETECTED": "Zistené",
          "NOT-DETECTED": "Nezistený",
          "MATCHED": "Zodpovedá",
          "NOT-MATCHED": "Nezodpovedá",
          "ENTERED-VALUE": "Zadaná hodnota",
          "SCANNED-VALUE": "Naskenovaná hodnota"
        },
        "FILES": "Súbory",
        "OPTIONS": "možnosti",
        "APPROVAL": {
          "TITLE": "Schválenie",
          "DESCRIPTION-TEXT": "Ak chcete túto správu schváliť, e-podpíšte sa nižšie.",
          "SIGN": "SIGN",
          "RESEND": "Znova odoslať žiadosť o schválenie",
          "NOT-SIGNED": "NIE PODPÍSANÉ",
          "DELETE-APPROVAL": "Naozaj chcete odstrániť?",
          "DELETE": "Odstrániť"
        },
        "SELECT-LANGUAGE": "Zvoľ jazyk",
        "MISSING-PARAMETERS": "Chýbajú parametre",
        "INVALID-TOKEN": "Neplatný Token",
        "REPORT-NOT-FOUND": "Správa sa nenašla",
        "SUCCESSFULLY-SENDED": "Úspešne odoslané",
        "REMOTE-CALL": {
          "TITLE": "Remote hovory",
          "STATUS": "Postavenie",
          "STEP": "Krok",
          "USERS": "Používatelia",
          "GUEST": "Host",
          "CALL-FAILED": "Hovor sa nezačal",
          "CREATED-AT": "Vytvorené o"
      }
      },
      "REPORT-LIST": {
        "NO-REPORT": {
          "TITLE": "Správa o pracovnom postupe",
          "TEXT": "Neexistuje žiadna správa.",
          "NO-REPORT-FOUND": "Nenašiel sa žiadny prehľad spojený s daným ID prepojenia"
        },
        "TITLE": "Reporty",
        "PLACEHOLDER": "Hľadajte podľa mena",
        "LIST": {
          "WORKFLOW": "Workflow",
          "VERSION": "Verzia",
          "SUBMITTED-BY": "Odovzdal",
          "SUBMITTED-TITLE": "Odovzdané",
          "SUBMITTED": "Odovzdané"
        },
        "LAST-SAVED": "Naposledy uložené",
        "PERMISSION-ERROR": "Nemáte povolenie na zobrazenie reportov",
        "ERROR": "CHYBA",
        "IMPORT-CANCELED": "Import bol zrušený",
        "REPORT-FORMAT-WRONG": "Formát správy je nesprávny",
        "IMPORT-SUCCESSFUL": "Import bol úspešný",
        "FILTER-ID": "Vyhľadávanie podľa ID značky",
        "ID-TAG": "Tag-ID"
      },
      "USER-DETAIL": {
        "CREATE_TITLE": "Vytvoriť používateľa",
        "EDIT_TITLE": "Upraviť používateľa",
        "EDIT_DETAILS": "Upraviť podrobnosti používateľa",
        "NAME": "Názov",
        "NAME_REQUIRED": "Názov je povinný",
        "NAME_PATTERN": "Názov môže obsahovať iba písmená, čísla, podtržníky ( _ ) a spojovníky ( - ).",
        "USERNAME": "Používateľské meno",
        "USERNAME_REQUIRED": "Vyžaduje sa používateľské meno.",
        "USERNAME_PATTERN": "Používateľské meno môže obsahovať iba písmená, čísla, podtržníky ( _ ) a spojovníky ( - ).",
        "USERNAME_EXISTS": "Užívateľské meno už existuje",
        "EMAIL": "Email",
        "EMAIL_REQUIRED": "Vyžaduje sa e-mail",
        "INVALID_EMAIL": "Neplatný formát e-mailu.",
        "SAVE_CHANGES": "ULOŽIŤ ZMENY",
        "DELETE_USER": "VYMAZAŤ POUŽÍVATEĽA",
        "CHANGE_PASSWORD": "Zmeniť heslo",
        "CREATE_PASSWORD": "Vytvor heslo",
        "NEW_PASSWORD": "Nové heslo",
        "CONFIRM_NEW_PASSWORD": "Potvrďte nové heslo",
        "SUBMIT_NEW_PASSWORD": "ZMENIŤ HESLO",
        "PASSWORD_REQUIRED": "Vyžaduje sa heslo.",
        "PASSWORD_REQUIREMENTS": "Heslo nespĺňa požiadavky uvedené nižšie.",
        "CONFIRM_PASSWORD": "Potvrďte heslo",
        "CONFIRM_REQUIRED": "Vyžaduje sa potvrdenie hesla.",
        "PASSWORD_MATCH": "Heslá sa nezhodujú.",
        "PASSWORD_MUST": "Heslo musí:",
        "MIN_LENGTH": "pozostávať z aspoň {{ minPasswordLength }} znakov",
        "UPPERCASE": "obsahovať aspoň jedno veľké písmeno (A-Z)",
        "LOWERCASE": "obsahovať aspoň jedno malé písmeno (a-z)",
        "NUMBER": "obsahovať aspoň jedno číslo (0-9)",
        "SPECIAL": "obsahovať aspoň jeden špeciálny znak (-*/?#&())",
        "SUBMIT": "VYTVORIŤ POUŽÍVATEĽA",
        "QR_CODE": "QR kód",
        "AUTHENTICATE": "Pomocou QR kódu môžete autentifikovať smart okuliare a mobilné telefóny.",
        "GENERATE_QR_CODE": "VYGENEROVAŤ QR",
        "REGENERATE_QR_CODE": "Obnoviť kód",
        "DOWNLOAD": "STIAHNUŤ",
        "DELETE": "VYMAZAŤ",
        "LIMIT-WARNING": "Používateľ bude vytvorený, ale jeho pracovné postupy nebudú licencované, pretože ste už dosiahli limit používateľov.",
        "DELETE-USER-OR-NOT": "Naozaj chcete odstrániť tohto používateľa?",
        "DELETE-QR-OR-NOT": "Naozaj chcete odstrániť tento QR kód?",
        "CREATED-SUCCESSFULLY": "Používateľ bol úspešne vytvorený. Limit používateľov pracovného postupu je však plný. Tento používateľ nie je používateľom pracovného postupu",
        "ROLE": "Rola",
        "EDITOR-ACCESS": "Prístup editora",
        "EDITOR-ACCESS-TEXT": "Používateľ dostane prístup k editoru, aby mohol vytvárať a upravovať pracovné postupy."
      },
      "USER-LIST": {
        "TITLE": "Používatelia",
        "CREATE": "VYTVORIŤ POUŽÍVATEĽA",
        "SIMPLIFY": "Chceli by ste vedieť, ako si zjednodušiť pracovné procesy, eliminovať papierovanie a zredukovať administratívne úkony? Naše softvérové riešenie je jednotné softvérové riešenie pre riadenie pracovných procesov, ktoré zníži zložitosť riadenia ľudských zdrojov a pracovných procesov. Toto softvérové riešenie je možné prispôsobiť vašim špecifickým potrebám a ide o škálovateľnú technológiu.",
        "LICENSED": "Používatelia licencovaného Workflow:",
        "SEARCH": "Vyhľadáť",
        "UNLIMITED": "Neobmedzené",
        "LIST": {
          "WORKFLOW-USER": "Používateľ pracovného toku",
          "NAME": "Názov",
          "USERNAME": "Používateľské meno"
        },
        "ACTIONS": {
          "OPTIONS": "Možnosti",
          "EDIT": "Upraviť",
          "DELETE": "Odstrániť"
        },
        "LICENCE-LIMIT": "Váš účet dosiahol maximálny počet odoslaní pracovného postupu. Aktualizujte svoju licenciu, aby ste videli najnovšie predložené pracovné postupy.",
        "DEACTIVATE": {
          "DEACTIVATED": "používateľ deaktivovaný",
          "SAVE": "Uložiť",
          "CANCEL": "Zrušiť"
        },
        "CHANGES-WARNING": "Existujú neuložené zmeny. Naozaj chcete zatvoriť?",
        "DELETE-OR-NOT": "Naozaj chcete odstrániť tohto používateľa?",
        "SAVE-SUCCESSFUL": "Uloženie bolo úspešné",
        "LIMIT-EXCEED": "Prekročenie limitu.",
        "ERROR": "Chyba",
        "USERS-AND-TEAMS": "Používatelia a tímy",
        "TEAMS": "Tímy",
        "CREATE-TEAM": "VYTVORIŤ TÍM",
        "TEAM": "Tím"
      },
      "WORKFLOW": {
        "REQUIRED": "Požadované pole",
        "SIDEBAR": {
          "DETAILS": "Podrobnosti",
          "EDITOR": "Editor",
          "CONNECTIONS": "Spojenia"
        },
        "WORKFLOW-DETAIL": {
          "TITLE": "Podrobnosti",
          "NAME": {
            "TITLE": "Názov",
            "REQUIRED": "požadovaný",
            "NO-NAME": "Toto pole je povinné"
          },
          "DESCRIPTION": "Popis",
          "DURATION": "Odhadované trvanie",
          "LABEL": {
            "TITLE": "Štítky",
            "CREATE": "Vytvor nový",
            "NO-ITEMS-FOUND": "Nenašli sa žiadne položky"
          },
          "SHOW-CONTENT-PAGE": "Zobraziť stránku s obsahom",
          "UPLOAD-FILE": "Nahrať súbor",
          "PREVIEW-TEXT": "Ak chcete upraviť pracovný postup, prejdite na kartu Editor.",
          "UPLOAD-FILE-INFO": "Môžete nahrať súbory obsahujúce informácie o tomto pracovnom postupe. V súčasnosti sú podporované iba súbory pdf.",
          "CONNECTION-WARNING": "„Stránka s obsahom“ sa nedá povoliť, pretože sú aktivované pripojenia.",
          "DELETE-FILE": "Naozaj chcete odstrániť tento súbor?"
        },
        "WORKFLOW-STEPS": {
          "STEP-LIST": {
            "INFORM": "Vytvorte nový krok pomocou tlačidla nižšie",
            "STEP": {
              "NO-NAME": "Vyžaduje sa názov kroku.",
              "OPTIONS": {
                "RENAME": "Premenovať",
                "DUPLICATE": "Duplikovať",
                "DELETE": "Odstrániť",
                "MOVE": "Presunúť",
                "CLONE": "Klonovať",
                "CLONE-STEP": "Klonovať krok",
                "MOVE-STEP": "Presunúť krok"
              },
              "CREATE": "Vytvoriť nový krok",
              "ADD-STEP": "Pridať krok"
            },
            "TEXT-MESSAGE": "Vaše zmeny budú odstránené. Chcete odstrániť kroky, ktoré ste pridali?",
            "CLONE-TEXT-MESSAGE": "Krok, ktorý ste vybrali, sa skopíruje do vybratého pracovného postupu.",
            "MOVE-TEXT-MESSAGE": "Krok, ktorý ste vybrali, sa presunie do vybratého pracovného toku a z tohto pracovného toku sa odstráni.",
            "SELECT": "Vybrať",
            "CREATE-SECTION": "Vytvoriť sekciu",
            "SECTION-TEXT-MESSAGE": "V tomto pracovnom postupe nie je žiadna sekcia. Po vytvorení sekcie sa do nej pridajú predtým vytvorené kroky. Chcete pokračovať?",
            "SECTION-DELETE-TEXT-MESSAGE": "Táto sekcia a kroky v nej budú odstránené. Ak niektoré kroky nechcete odstrániť, môžete ich pred odstránením presunúť.",
            "INDEPENDENT": "Kroky nemôžu byť nezávislé od sekcie",
            "DELETE-STEP": "Vybrané kroky budú vymazané. Naozaj chcete odstrániť kroky uvedené nižšie?" ,
            "INITIAL-STEP-WARNING-MESSAGE": "Zvolený krok je počiatočným krokom pracovného postupu. Pred odstránením musíte zmeniť počiatočný krok.",
            "CONNECTED-STEPS-WARNING-MESSAGE": "S týmito krokmi sú spojené kroky. Ak odstránite tento krok, vaše pripojenia budú preč. Skontrolujte svoje pripojenia na stránke pripojenia."
          },
          "STEP-PREVIEW": {
            "NO-STEP": "Nevybrané"
          },
          "WIDGET-PROPERTIES": {
            "EMPTY": "Kliknutím sem pridáte obsah.",
            "INFORM": "V náhľade krokov môžete vidieť, ako sa váš obsah zobrazí používateľovi.",
            "BACK": "Späť",
            "POSITION": {
              "TITLE": "Poloha",
              "HORIZONTAL": "Horizontálna poloha",
              "VERTICAL": "Vertikálna poloha"
            },
            "LABEL": {
              "TITLE": "Názov",
              "REQUIRED": "požadovaný",
              "NO-LABEL": "Štítok je povinný."
            },
            "PLACEHOLDER": "Placeholder",
            "OPTIONS": {
              "TITLE": "Možnosti",
              "NO-LABEL": "Štítok je povinný.",
              "MUST-UNIQUE": "Štítky možností musia byť jedinečné.",
              "DELETE-LAST": "- Posledná položka sa nedá odstrániť",
              "ADD": "Pridať možnosť",
              "MAX-ADDED": "Pridanie veľkého počtu prvkov môže vyžadovať posúvanie na inteligentných okuliaroch"
            },
            "NUMBER-FIELDS": {
              "MIN": "Min",
              "MAX": "Max",
              "UNIT": "Jednotka",
              "PRECISION": "Presnosť"
            },
            "PPE-FIELDS": {
              "TITLE": "Zistite nasledujúce zariadenia:",
              "FACE": "Ochrana tváre",
              "HEAD": "Ovchrana hlavy",
              "HAND": "Ochrana rúk",
              "NO-RECOGNITION": "Vyberte aspoň jedno rozpoznávanie OOP."
            },
            "TIME-PICKER": "Dátum zahŕňa čas",
            "QR-FIELD": "Hodnota QR kódu",
            "QR-ACTIVATION": "Aktivujte overenie QR",
            "QR-FIELD-VALIDATION-TEXT": "Pole QR je povinné.",
            "QR-ACTIVATION-INFO-TEXT": "Keď je aktivované overenie QR, vami poskytnutá hodnota QR kódu (odkaz QR) sa porovná s QR kódom naskenovaným používateľom, aby sa zistilo, či sa zhodujú.",
            "REQUIRED": {
              "TEXT": "Nastavte toto pole ako povinné",
              "INFORM": "Aktivujte toto tlačidlo, ak sa chcete uistiť, že tento krok nemôže používateľ preskočiť."
            },
            "IMAGE": {
              "TITLE": "Nahrať obrázok",
              "REQUIRED": "požadovaný",
              "UPLOAD": {
                "DRAG-DROP": "Chyť a pusti",
                "INFORM": "Presuňte súbory alebo ich nahrajte kliknutím na tlačidlo",
                "CLICK": {
                  "UPLOAD": "Nahrať obrázok",
                  "CHANGE": "Zmeniť obrázok",
                  "EDIT": "Upraviť obrázok"
                }
              },
              "NO-IMAGE": "Vyžaduje sa obrázok."
            },
            "GALLERY": {
              "TITLE": "Nahrať obrázky",
              "REQUIRED": "požadovaný",
              "NO-IMAGE": "Vyžaduje sa obrázok",
              "DELETE-IMAGE-TEXT-MESSAGE": "Naozaj chcete odstrániť tento obrázok?",
              "VALIDATION-TEXT": "Môžete nahrať maximálne 50 obrázkov.",
              "DELETE-IMAGE": "Odstrániť obrázok"
            },
            "VIDEO": {
              "TITLE": "Nahrať video",
              "REQUIRED": "požadovaný",
              "UPLOAD": {
                "DRAG-DROP": "Chyť a pusti",
                "INFORM": "Presuňte súbory alebo ich nahrajte kliknutím sem",
                "CLICK": {
                  "UPLOAD": "Nahrať video",
                  "CHANGE": "Zmeniť video"
                }
              },
              "NO-IMAGE": "Video je povinné."
            },
            "PDF": {
              "TITLE": "Nahrať súbor PDF",
              "REQUIRED": "požadovaný",
              "UPLOAD": {
                "DRAG-DROP": "Chyť a pusti",
                "INFORM": "Presuňte súbory alebo ich nahrajte kliknutím sem",
                "CLICK": {
                  "UPLOAD": "Nahrať súbor PDF",
                  "CHANGE": "Zmeniť PDF"
                }
              },
              "NO-IMAGE": "Vyžaduje sa PDF."
            },
            "TABLE": {
              "CREATE-TABLE": "Vytvorte tabuľku",
              "COLUMN": "Stĺpec",
              "ROW": "riadok",
              "CREATE": "Vytvorte",
              "ADD-ROW": "Pridať riadok",
              "DELETE-ROW": "Odstrániť riadok",
              "ADD-COLUMN": "Pridať stĺpec",
              "DELETE-COLUMN": "Odstrániť stĺpec",
              "SELECT-CELL-TEXT": "Ak chcete vyplniť tabuľku, vyberte bunku",
              "SELECT-CONTENT-TYPE-TEXT": "Vyberte typ obsahu"
          },
            "TEXT-MESSAGE": "Naozaj chcete nahradiť miniaplikáciu?",
            "DELETE-TEXT-MESSAGE": "Naozaj chcete odstrániť miniaplikáciu?",
            "TITLE-DELETE": "Odstrániť miniaplikáciu",
            "TITLE-CHANGE": "Nahradiť widget",
            "REPLACE": "Nahradiť",
            "DELETE-ROW-TEXT-MESSAGE": "Naozaj chcete odstrániť riadok?",
            "DELETE-COLUMN-TEXT-MESSAGE": "Naozaj chcete odstrániť stĺpec?",
            "TITLE-DELETE-ROW": "Odstrániť riadok",
            "TITLE-DELETE-COLUMN": "Odstrániť stĺpec",
            "CONNECTION-WARNING-TEXT-MESSAGE": "Tento widget nemôžete zmeniť. Pretože je to spojený s podmienkou.",
            "CONNECTION-WARNING-HEADER": "Upozornenie na pripojenie",
            "WIDGET-TITLES": {
              "LABEL": "Štítok",
              "TEXT-INPUT": "Textový vstup",
              "NUMBER-INPUT": "Zadanie čísla",
              "DATE-PICKER": "Výber dátumu",
              "CHECKBOX": "Začiarkavacie políčko",
              "RADIO-BUTTON": "Tlačítko Rádio",
              "IMAGE": "Obrázok",
              "VIDEO": "Video",
              "PDF": "PDF",
              "DETECT-QR": "Rozpoznať QR",
              "CAPTURE-IMAGE": "Zachytiť obrázok",
              "CAPTURE-VIDEO": "Zaznamenať video",
              "PPE": "OOP",
              "VOICE-RECORD": "Hlasový záznam",
              "VOICE": "Hlas",
              "VSIGHT-REMOTE": "Vsight Remote",
              "AR-INSTRUCTION": "Inštrukcie AR",
              "HTML": "Bohatý text",
              "GALLERY": "Galéria",
              "TABLE": "Tabuľky",
              "FORM": "Formulár",
              "WORKFLOW": "Workflow",
              "ID": "ID",
              "SIGNATURE": "Podpis"
            },
            "WIDGET-DESCRIPTION": {
              "INSTRUCTION": "Inštrukcia",
              "FEEDBACK": "Spätná väzba",
              "VISUAL-SUPPORT": "Vizuálna podpora",
              "AUGMENTED-REALITY": "Rozšírená realita",
              "VISUAL-AI": "Vizuálna AI",
              "COMING-SOON": "Už čoskoro",
              "FULLSCREEN": "Dostupné iba na celej stránke"
            },
            "LIMIT-EXCEED": "Prekročenie limitu. Maximálny limit je 50."
          },
          "STEP-FILES": {
            "TITLE": "Súbory krokov",
            "VIEW-STEP-FILES": "Zobraziť Step Files"
        }
        },
        "TITLE": "Pracovný tok",
        "APPROVE": "Schváliť",
        "CANCEL": "Zrušiť",
        "SAVE": "Uložiť koncept",
        "PUBLISH": "PUBLIKOVAŤ",
        "SAVE-PUBLISH": "Uložiť a zverejniť",
        "EDIT-WORKFLOW": "UPRAVIŤ PRACOVNÝ POSTUP",
        "EDIT-WORKFLOW-TITLE": "Upraviť pracovný postup",
        "EDIT-MODE-TEXT-MESSAGE": "Teraz ste v režime prehliadania. Ak chcete vykonať zmeny, kliknite na tlačidlo „UPRAVIŤ PRACOVNÝ FLOW“.",
        "STEP-PREVIEW": "Ukážka kroku",
        "WIDGET-PROPERTIES": "Vyberte rozloženie z ukážky kroku a pridajte miniaplikácie.",
        "CONNECTIONS-PAGE": "Stránka pripojenia",
        "CHANGE-STEP-LAYOUT": "Zmeniť rozloženie krokov",
        "ERROR-MESSAGE": {
          "MESSAGE": "Ak nie je jedna strana rozloženia prázdna, nemôžete prepnúť do režimu celej strany.",
          "NOT-SUPPORT": "Tento widget nie je podporovaný vo vybratom rozložení.",
          "CONFIRM": "Zavrieť"
        },
        "TEXT-MESSAGE": {
          "MESSAGE": "Naozaj chcete zatvoriť editor? Neuložené zmeny sa stratia.",
          "CONFIRM": "Zavrieť",
          "OK": "OK"
        },
        "PREVIEW": {
          "DETECT-QR": "Rozpoznať QR kód/čiarový kód",
          "DETECT-PPE": "Zistite OOP z fotoaparátu",
          "PICK_IMAGE": "Vyberte obrázok",
          "PICK-VIDEO": "Vyberte video",
          "CAPTURE-VIDEO": "Zachyťte video",
          "CAPTURE-IMAGE": "Vytvoriť obrázok",
          "DETECT-PPE-FROM-FINDER": "Vyberte obrázok PPE",
          "DETECT-QR-WITH-UPLOAD": "Vyberte QR kód/čiarový kód",
          "DETECT-QR-WITH-CAMERA": "Rozpoznať QR kód/čiarový kód",
          "SIGN-HERE": "Podpíšte sa tu"
        },
        "WORKFLOW-CONNECTIONS": {
          "CONDITIONS": "Podmienky",
          "ADD-CONDITION": "Pridať podmienku",
          "INFORM-TEXT": "Mali by ste vybrať krok na pridanie podmienky.",
          "FROM": "Od",
          "TO": "Do",
          "DELETE-CONNECTION": "Odstrániť pripojenie",
          "WHEN": "Kedy",
          "REQUIRED-FIELD": "Požadované pole",
          "ADD-LOGICAL-CONDITION": "Pridajte logickú podmienku",
          "DELETE-CONDITION": "Odstrániť podmienku",
          "CONDITION": "Podmienka",
          "GO-TO": "Ísť do",
          "ELSE-CONDITION-TEXT": "Ak neplatia žiadne podmienky, prejdite na",
          "NOT-SELECTED": "Nevybraté",
          "TURN-ON-CONNECTIONS": "Zapnúť Pripojenia",
          "TURN-ON-CONNECTIONS-TEXT": "Možete zapnúť tab Pripojení, pre vytvorenie podmineného postupu a editovať prepojenia medzi korkmi.",
          "SELECT": "Vybrať",
          "ENTER": "Zadať",
          "CONTENT-PAGE-WARNING-TEXT": "Naozaj chcete zapnúť Pripojenia?",
          "CONTENT-PAGE-IMPORTANT-WARNING-TEXT": "UPOZORNENIE: Zapnutím Pripojení natrvalo zakážete funkciu „Stránka s obsahom“ v tomto pracovnom postupe.",
          "CONFIRM": "Áno",
          "INITIAL-STEP-CHANGE-TEXT": "Počiatočný krok môžete zmeniť kliknutím sem",
          "INITIAL-STEP-CHANGE-WARNING-TEXT": "Tento krok nemôže byť počiatočným krokom, pretože existujú kroky, ktoré sú spojené s vybraným krokom.",
          "INVALID-DATA": "Tento krok nie je možné automaticky uložiť z dôvodu neplatných údajov.",
          "ALREADY-CONNECTED": "Nemôžete vytvoriť spojenie medzi už pripojenými krokmi."
        },
        "HEADER-TITLES": {
          "CLOSE-WORKFLOW": "Zatvoriť pracovný postup",
          "PUBLISH-WORKFLOW": "Publikovať pracovný postup",
          "DELETE-USER": "Odstrániť používateľa",
          "DELETE-WORKFLOW": "Odstrániť pracovný postup",
          "WARNING": "Upozornenie",
          "DELETE-FILE": "Vymazať súbor",
          "DELETE-SECTION": "Odstrániť sekciu",
          "DELETE-STEP": "Odstrániť krok",
          "LOGOUT": "Odhlásiť sa",
          "LICENCE-WARNING": "Licenčné upozornenie",
          "DUPLICATE-WORKFLOW": "Doplikovať pracovný postup",
          "SELECT-DEFAULT-LANGUAGE": "Vyberte Predvolený jazyk"
        },
        "LANGUAGE": {
          "SEARCH": "Vyhľadávanie",
          "ADDED": "Pridané",
          "DEFAULT": "Predvolené",
          "NOT-ADDED": "Not Added",
          "LANGUAGE-INFO-TEXT": "Vytvorte pre svojich používateľov viacjazyčný pracovný postup pridaním nového jazyka. Môžete tiež zmeniť primárny jazyk, v ktorom uprednostňujete zobrazenie pracovného postupu pre vašich používateľov, a to tak, že ho nastavíte ako predvolený jazyk.",
          "SELECT-LANGUAGE": "Zvoľ jazyk",
          "CHECK-LANGUAGE": "Po automatickom preklade ste vykonali zmeny. Prosím, nezabudnite skontrolovať všetky jazyky!",
          "DELETE-LANGUAGE-OR-NOT": "Naozaj chcete odstrániť jazyk? Všetok obsah vo vybranom jazyku sa stratí."
        },
        "DELETE": "Odstrániť",
        "WORKFLOW-NOT-FOUND": "Pracovný postup nebol priradený k odkazu",
        "SAVE-SUCCESSFUL": "Uloženie je úspešné",
        "SAVE-ERROR": "Chyba uloženia",
        "CLONED": "Úspešne klonované"
      },
      "EASY-ACCESS": {
        "MANAGE-PUBLIC-ACCESS": "Spravovať verejný prístup",
        "MANAGE-PUBLIC-ACCESS-TEXT": "Zdieľanie tohto pracovného postupu môžete zastaviť odstránením verejného prístupu.",
        "GENEATE-ACCESS-TEXT": "Môžete vygenerovať verejný odkaz a QR kód na vytvorenie jednoduchého prístupu k tomuto pracovnému postupu.",
        "ENABLE-PASSWORD": "Povoliť heslo",
        "GENERATE-ACCESS": "Vytvorte jednoduchý prístup",
        "LINK": "Odkaz",
        "COPY": "Kopírovať",
        "QR-CODE": "QR kód",
        "DOWNLOAD": "Stiahnuť",
        "SECURITY": "Zabezpečenie",
        "PASSWORD-PROTECTED": "Chránené heslom",
        "PUBLIC": "Verejné",
        "DELETE-ACCESS": "Odstrániť verejný prístup",
        "EASY-ACCESS-TITLE": "Jednoduchý prístup k {{ shortName }} Workflow",
        "OPEN-WORKFLOW-NAME": "Chystáte sa otvoriť",
        "GUEST-EMAIL": "E-mail hosťa",
        "REQUIRED": "Toto pole je povinné",
        "GUEST-PASSWORD": "Heslo pre hosťa",
        "OPEN": "OTVORENÉ",
        "OPEN-APP": "Tento pracovný postup môžete otvoriť v aplikácii pre lepší zážitok.",
        "COPY-LINK-TEXT": "Skopírujte odkaz do schránky na otvorenie tohto pracovného postupu pri spustení aplikácie.",
        "DOWNLOAD-APP": "STIAHNUŤ APLIKÁCIU",
        "OR": "ALEBO",
        "CONTINUE-WITH-BROWSER": "Pokračujte v prehliadači",
        "PASSWORD-PROTECTED-TEXT": "Keď je heslo povolené, používatelia, ktorí majú verejný odkaz alebo QR kód, budú mať prístup k pracovnému postupu až po zadaní hesla.",
        "CREATE-PASSWORD": "Vytvoriť heslo",
        "ENTER-EMAIL": "Zadajte svoj e-mail",
        "ENTER-WORKFLOW-PASSWORD": "Zadajte heslo pracovného postupu",
        "DELETE-QR-TEXT": "Ak chcete zmeniť typ zabezpečenia jednoduchého prístupu, mali by ste odstrániť jednoduchý prístup a vygenerovať ho znova.",
        "LOADING-WORKFLOW": "Načítanie pracovného postupu...",
        "UNABLE-TO-LOAD": "Nie je možné načítať pracovný postup",
        "RETRY": "Skúsiť znova",
        "GUEST-ACCESS": {
          "TOKEN-MISSING": "Token chýba alebo je neplatný",
          "ID-MISSING": "Chýba ID pracovného postupu alebo základná adresa URL",
          "WORKFLOW-NOT-PUBLISHED": "Pracovný postup nie je zverejnený",
          "PUBLIC-ACCESS": "Verejný prístup už existuje",
          "NO-PUBLIC-ACCESS": "Žiadny verejný prístup"
        },
        "QR-INFORMATION": "QR informácie"
      },
      "WORK-ORDERS": {
        "TITLE": "Work Orders",
        "CREATE-WORK-ORDER": "Create Work Order",
        "EDIT-WORK-ORDER": "Edit Work Order",
        "EDIT": "Upraviť",
        "CREATE": "Vytvorte",
        "DELETE": "Odstrániť",
        "SAVE-CHANGES": "Uložiť zmeny",
        "TO-DO": "Robiť",
        "DONE": "Hotový",
        "EMPTY-LIST": "No work orders found.",
        "PRIORITY": {
            "high": "Vysoká",
            "medium": "Stredná",
            "low": "Nízka"
        },
        "STATUS": {
            "open": "OTVORENÉ",
            "in-progress": "Prebieha",
            "on-hold": "Podržané",
            "done": "Hotový"
        },
        "SELECT-DUE-DATE": "Do dátumu",
        "SELECT-RECURRENCE": "Opakovanie",
        "NO-ITEMS-FOUND": "Nenašli sa žiadne položky",
        "RECURRENCE": {
            "none": "Žiadne",
            "daily": "Denne",
            "weekly": "Týždenne",
            "monthly": "Mesačne"
        },
        "ITEMS": {
            "ID": "ID",
            "PRIORITY": "Priorita",
            "DUE-DATE": "Do dátumu",
            "TASK-NAME": "Názov úlohy",
            "STATUS": "Postavenie",
            "ADD-DUE-TIME": "Pridajte čas",
            "CLEAR-DUE-TIME": "Čistý čas",
            "RECURRENCE": "Opakovanie",
            "DESCRIPTION": "Popis",
            "FILES": "Súbory",
            "ASSIGNED-WORKFLOWS": "Priradené Workflows",
            "ADD-WORKFLOW": "Pridať Workflow",
            "ASSIGNED-TO": "Priradený",
            "SELECT-USER": "Vyberte používateľa",
            "ACTIVITY": "Aktivita"
        },
        "WARNING": {
            "DELETE-WORK-ORDER-TITLE": "Delete Work Order",
            "DELETE-WORK-ORDER-TEXT": "Are you sure you want to delete this work order?"
        }
    },
            "VIDEO-FLOW-DASHBOARD": {
                "TITLE": "Video toky",
                "CREATE-VIDEO-FLOW": "Vytvoriť video tok",
                "CREATED-BY-AI": "Vytvorené AI",
                "VERSION": "Verzia",
                "NO-VIDEO-FLOWS-FOUND": "Nenašli sa žiadne video toky",
                "CLEAR-ALL": "Vymazať všetko",
                "CONFIRM-VIDEO": "Potvrdiť video",
                "CONFIRM-VIDEO-TITLE": "Potvrdiť konverziu videa",
                "CONFIRM-VIDEO-MESSAGE": "Naozaj chcete previesť tento video tok na workflow? Po potvrdení nebudete môcť video upravovať.",
                "CONFIRM-VIDEO-BUTTON": "Potvrdiť a previesť",
                "MAKE-WORKFLOW-SUCCESSFUL": "Úspešne prevedené na workflow",
                "MAKE-WORKFLOW-ERROR": "Nepodarilo sa previesť na workflow",
                "UPLOAD-VIDEO-DESCRIPTION": "Nahrajte svoje video a automaticky vygenerujte sprievodcu workflow krok za krokom.",
                "VIDEO-DURATION-LIMIT": "Dĺžka videa nesmie presiahnuť 30 minút.",
                "VIDEO-UPLOADED-SUCCESS": "Video bolo úspešne nahrané!",
                "SELECT-VIDEO": "Vybrať video",
                "CHANGE-VIDEO": "Zmeniť video",
                "CREATE-BUTTON": "Vytvoriť",
                "AI-PROCESSING": "Prebieha spracovanie AI",
                "SPLITTING-VIDEO": "Rozdelenie videa na segmenty",
                "TRANSCRIBING-VIDEO": "Prepísanie obsahu videa",
                "PROCESS-WARNING": "Tento proces môže trvať až 10 minút. Nezavírajte prosím toto okno."
            }
    },
    "NAVBAR": {
      "LOGOUT": {
        "TEXT": "Odhlásiť sa",
        "TEXT-MESSAGE": {
          "MESSAGE": "Naozaj sa chcete odhlásiť?",
          "CONFIRM": "Odhlásiť sa"
        }
      }
    },
    "SIDEBAR": {
      "WORKFLOWS": "Pracovné postupy",
      "USERS": "Používatelia",
      "REPORTS": "Reporty",
      "DRAFTS": "Reporty",
      "SWITCH-ADMIN-PANEL": "Prepnúť na Editor",
      "SWITCH-USER-PANEL": "Prepnite na používateľský panel",
      "SWITCH-ADMIN-PANEL-TEXT": "Ak chcete vytvárať a upravovať pracovné postupy, prepnite z panela Používateľ na Editor.",
      "SWITCH-USER-PANEL-TEXT": "Ak chcete dokončiť pracovné postupy, prepnite z Editora na panel Používateľ."
    },
    "USER-WORKFLOW": {
      "ADD": "PRIDAŤ",
      "INVALID-EMAIL": "Neplatný email",
      "SEND-REQUEST": "Pošlite žiadosť na:",
      "REMOVE": "ODSTRÁNIŤ",
      "APPROVAL-REQUEST": "Žiadosť o schválenie",
      "REQUEST-SENDED-TEXT": "Vaša žiadosť o schválenie bola úspešne odoslaná na uvedené e-mailové adresy.",
      "CLOSE": "ZAVRIEŤ",
      "LICENCE-LIMIT": "Váš účet dosiahol maximálny počet odoslaní pracovného postupu. Správca účtu uvidí správu po inovácii licencie.",
      "REQUEST-PENDING": "Žiadosť o schválenie čaká na spracovanie",
      "REQUEST-APPROVAL": "Požiadať o schválenie správy",
      "SEND-REQUEST-TITLE": "POSLAŤ ŽIADOSŤ",
      "TASK-TO-COMPLETE": "Úloha na dokončenie:",
      "SELECT-LANGUAGE": "Zvoľ jazyk",
      "CONTENT-LANGUAGE": "Jazyk obsahu:",
      "ESTIMATED-DURATION": "Odhadované trvanie:",
      "DELETE": "Odstrániť",
      "DELETE-APPROVAL": "Naozaj chcete odstrániť?",
      "EMAIL-INVALID": "Formát e-mailu je neplatný",
      "MISSING-EQUIPMENT": "Chýbajúce vybavenie",
      "PROTECTED-EQUIPMENT": "Používajte prosím požadované osobné ochranné prostriedky",
      "CONTINUE-WITH-QR-WARNING-TEXT": "Chystáte sa odovzdať svoj pracovný postup ako predvyplnený. Vygeneruje sa odkaz a QR kód pre predvyplnený pracovný postup, ku ktorému bude možné pristupovať a pokračovať v ňom neskôr. Po vygenerovaní QR kódu nie je možné predvyplnené kroky upravovať. Naozaj chcete pokračovať?",
      "CONTINUE-WITH-QR-TITLE": "ODOVZDAJTE PREDPLNENÝ PRACOVNÝ POSTUP",
      "TABLE-OF-CONTENTS": "Obsah",
      "CALL-EXPERT": "Zavolajte odborníka",
      "HAND-OVER": "Odovzdať",
      "CANCEL": "ZRUŠIŤ",
      "CALL": "ZAVOLAJTE",
      "SAVE-CHANGES": "Uložiť zmeny",
      "CALL-PERMISSION-WARNING": "Nemáte povolenie zavolať odborníka. Kontaktujte správcu systému.",
      "SELECT-EXPERT-TEXT": "Vyberte odborníka, ktorému chcete zavolať:",
      "ERRORS": {
        "INTEGRATION-NOT-FOUND": "Integrácia sa nenašla"
      },
      "QR-NOT-MATCHED": "QR kód sa nezhoduje",
      "STEP-FILES": {
        "TITLE": "KROKOVÉ SÚBORY"
      }
    },
    "LOBBY": {
      "LOBBY_SHARED": {
        "ONGOING_CALLS_TITLE": "Prebiehajúce hovory",
        "ROOMS_TITLE": "Vaše Miestnosti",
        "UPCOMING_MEETINGS_TITLE": "Nadchádzajúce stretnutia",
        "PREVIOUS_MEETINGS_TITLE": "Predchádzajúce stretnutia",
        "SCHEDULE_MEETING": "Naplánujte stretnutie",
        "INSTANT_GUEST_ACCESS": "Okamžitý hosťovský prístup",
        "INSTANT_GUEST_ACCESS_NO_CALLING": "Nemáte oprávnenie na uskutočňovanie hovorov. Kontaktujte svojho administrátora.",
        "INSTANT_GUEST_ACCESS_NO_GUEST_ACCESS": "Nemáte oprávnenie na vytvorenie odkazu na hosťovský prístup. Kontaktujte svojho administrátora.",
        "INSTANT_GUEST_ACCESS_NO_PERM": "Nemáte oprávnenie na uskutočňovanie hovorov ani na vytvorenie odkazu na hosťovský prístup. Kontaktujte svojho administrátora.",
        "LINK_UNAVAILABLE": "Odkaz je nedostupný",
        "JOIN": "PRIPOJTE SA",
        "CANCEL": "ZRUŠIŤ",
        "REMOVE": "ODSTRÁNIŤ",
        "NO_ROOM": "Nemáte žiadnu miestnosť.",
        "NO_MEETING": "Nemáte žiadne stretnutie.",
        "NO_PREV_MEETING": "Nemáte žiadne stretnutie.",
        "NO_OTHER_USERS": "Žiadni ďalší používatelia",
        "SHOW_MORE": "zobraziť {{ count }} viac",
        "SHOW_LESS": "ukázať menej"
      },
      "SCHEDULE_MEETING_MODAL": {
        "TITLE": "Naplánujte Stretnutie",
        "MEETING_TITLE": "Názov*",
        "MEETING_TITLE_REQUIRED": "Vyžaduje sa názov",
        "START_DATE": "Štart",
        "END_DATE": "Koniec",
        "CLOSE": "Zavrieť",
        "SCHEDULE_SEND": "Naplánovať a odoslať",
        "SCHEDULE": "Naplánovať",
        "CANNOT_SCHEDULE": "Pri plánovaní stretnutia sa vyskytla chyba.",
        "CANNOT_CANCEL_MEETING": "Pri rušení stretnutia sa vyskytla chyba.",
        "ENTER_USERS": "Zadajte používateľov",
        "SEND_INVITATIONS": "Poslať pozvánky",
        "INVITATION_EMAIL_LANG": "Jazyk e-mailu s pozvánkou",
        "SHARE_AFTER": "Odkaz na stretnutie je možné zdieľať aj po naplánovaní."
      },
      "CANCEL_MEETING_MODAL": {
        "CANCEL_TITLE": "Zrušiť stretnutie",
        "REMOVE_TITLE": "Odstrániť stretnutie",
        "CANCEL_MESSAGE": "Naozaj chcete zrušiť stretnutie?",
        "REMOVE_MESSAGE": "Naozaj chcete odstrániť stretnutie?",
        "CLOSE": "Zavrieť",
        "PROCEED": "Pokračovať"
      },
      "CONTACTS": {
        "TITLE": "Používatelia",
        "NO_PERMISSION": "Nemáte povolenie na zobrazenie zoznamu používateľov a hovorov.",
        "NO_CONTACT": "Zoznam používateľov je prázdny.",
        "SELECT_MULTI": "Vybrať viacero",
        "CALL": "Zavolať",
        "ADMIN": "Správca",
        "COADMIN": "Spolusprávca",
        "EXPERT": "Expert",
        "SUBSCRIBER": "Predplatiteľ",
        "USER": "Používateľ",
        "NAME": "Meno",
        "USERNAME": "Používateľské meno",
        "ROLE": "Rola",
        "NO_EXPERT": "Na uskutočnenie hovoru vyberte aspoň jedného odborníka.",
        "NAME_USERNAME": "Meno alebo Používateľské meno",
        "ALL_ROLES": "Všetky roly"
      },
      "SESSIONS": {
        "TITLE": "Relácie",
        "DATE": "Vytvorené na",
        "DURATION": "Trvanie",
        "ROOM_NAME": "Miestnosť",
        "NO_SESSIONS": "Zoznam relácií je prázdny.",
        "PARTICIPANTS": "Účastníci",
        "EXPORT": "Export",
        "STATUS": "Postavenie",
        "ON_GOING": "Prebieha",
        "ENDED": "Ukončený",
        "FILES": "Súbory",
        "CHAT": "Chat",
        "SESSION_FILES": {
          "MULTIPLE_SELECTION": "Vybrať viacero",
          "DOWNLOAD": "Stiahnuť",
          "DOWNLOAD_STARTED_SOON": "Sťahovanie bude čoskoro spustené.",
          "DOWNLOAD_FAILED": "Sťahovanie zlyhalo.",
          "NO_FILE_IS_ADDED": "V tejto relácii nie je pridaný žiadny súbor ani s ním nespolupracuje.",
          "SUCCESS_MESSAGE": "Súbory boli úspešne stiahnuté."
        },
        "ATTACHED_TICKET": "Priložený tiket",
        "SESSION_DETAILS": "Podrobnosti relácie",
        "BACK": "Späť",
        "GET_SESSION_EXPORT": "Získajte export relácie",
        "ATTACH_TO_TICKET": "Pripojte k tiketu"
      },
      "TICKETS": {
        "TITLE": "Tikety",
        "NEW_TICKET": "Nový lístok",
        "ALL_ROOMS": "Všetky miestnosti",
        "ALL_STATUSES": "Všetky stavy",
        "NO_TICKETS": "Zoznam tiketov je prázdny.",
        "TICKET_TITLE": "Názov",
        "ROOM": "Miestnosť",
        "CREATED_BY": "Vytvoril",
        "CREATED_ON": "Vytvorené na",
        "STATUS": "Status",
        "STATUS_OPEN": "Otvoriť",
        "STATUS_IN_PROGRESS": "Prebieha",
        "STATUS_CLOSED": "Zatvorené",
        "CLOSE_PICK_TICKET": "ZAVRIEŤ",
        "CREATE_NEW": "VYTVOR NOVÝ",
        "ATTACH": "PRILOŽIŤ",
        "CREATE_TICKET": "Vytvoriť tiket",
        "TICKET_DETAILS": "Podrobnosti tiketu",
        "EDIT": "UPRAVIŤ",
        "TICKET_TYPE": "Typ tiketu",
        "ROOM2": "Miestnosť:",
        "CREATED_BY2": "Vytvoril:",
        "CREATED_ON2": "Vytvorené na:",
        "ROOM3": "Miestnosť",
        "STATUS2": "Status",
        "PRIORITY": "Priorita",
        "ASSIGNEE": "Nadobúdateľ",
        "FOLLOW_UP": "Nasledujúci termín",
        "TICKET_TITLE2": "Názov",
        "TITLE_REQUIRED": "Vyžaduje sa názov",
        "DESCRIPTION": "Popis",
        "DESCRIPTION_REQUIRED": "Vyžaduje sa popis",
        "RESOLUTION": "Rozhodnutie",
        "ATTACHED_SESSIONS": "PRIPOJENÉ RELÁCIE",
        "NO_ATTACHED_SESSIONS": "Zoznam pripojených relácií je prázdny",
        "SESSION_COUNT": "Počet relácií:",
        "TOTAL_DURATION": "Celkové trvanie:",
        "PARTICIPANTS2": "Účastníci:",
        "COUNT_SESSIONS": " {{count}} Relácií",
        "DATE": "Dátum",
        "ROOM_NAME": "Názov miestnosti",
        "PARTICIPANTS": "Účastníci",
        "DURATION": "Trvanie",
        "GUEST": "(Hosť)",
        "CANCEL": "ZRUŠIŤ",
        "CLOSE": "ZAVRIEŤ",
        "SAVE": "ULOŽIŤ",
        "CREATE": "VYTVORIŤ",
        "CREATED_BETWEEN": "Vytvorené medzi",
        "ALL_CREATORS": "Všetci Tvorcovia",
        "SEND_VIA_EMAIL": "POSLAŤ E-MAILOM",
        "DELETE_TICKET": "VYMAZAŤ TIKET",
        "DELETE_TICKET_MODAL": {
          "TITLE": "Odstrániť tiket?",
          "MESSAGE": "Naozaj chcete odstrániť tiket <strong>{{title}}</strong>?",
          "CANCEL": "ZRUŠIŤ",
          "DELETE": "VYMAZAŤ"
        },
        "LOW": "Nízka",
        "MEDIUM": "Stredná",
        "HIGH": "Vysoká",
        "CHOOSE_TICKET": "Vyberte lístok",
        "ERRORS": {
          "TICKET_ALREADY_ATTACHED": "Lístok je už priložený.",
          "ERROR_OCCURED": "Vyskytla sa chyba.",
          "PERMISSION_DENIED": "Prístup zamietnutý.",
          "MISSING_PARAMETERS": "Chýbajú parametre",
          "FILE_ALREADY_EXIST": "Súbor už existuje"
      },
        "FILES": "Súbory",
        "UPLOAD_FILE": "NAHRAJTE SÚBOR"
      },
      "ARCHIVES": {
        "ARCHIVE_LIST": {
          "REFRESH": "Obnoviť",
          "LOADING": "Načítavajú sa záznamy videohovorov",
          "NO_ARCHIVE_MESSAGE": "Neexistuje žiadny záznam videohovoru",
          "NAME": "Názov",
          "CREATED_AT": "Vytvorené v",
          "STORAGE": "Skladovanie",
          "DURATION": "Trvanie",
          "ARCHIVES": "Záznamy videohovorov",
          "SIZE": "Veľkosť súboru",
          "STATUS": "Status",
          "AVAILABLE": "k dispozícii",
          "DISCONNECTED": "odpojený",
          "DELETED": "vymazané",
          "EXPIRED": "platnosť vypršala",
          "WAITING": "čakanie",
          "FAILED": "zlihalo",
          "DOWNLOAD": "Stiahnuť",
          "PLAY": "Prehrať",
          "DELETE": "Odstrániť",
          "DOWNLOAD_ARCHIVE": {
            "TITLE": "Stiahnite si záznam",
            "GENERATING": "Generuje sa adresa URL na stiahnutie",
            "GENERATED": "Vygenerovaná adresa URL na stiahnutie",
            "CANNOT_GENERATED": "Nedá sa vygenerovať URL na stiahnutie.",
            "DOWNLOAD": "Stiahnuť",
            "CLOSE": "Zavrieť"
          },
          "DELETE_ARCHIVE": {
            "TITLE": "Odstrániť záznam",
            "MESSAGE": "Záznam videohovoru bude vymazaný.",
            "CAUTION": "UPOZORNENIE: Tento záznam sa odstráni aj z vášho úložiska Azure.",
            "CANCEL": "Zrušiť",
            "DELETE": "Odstrániť"
          }
        }
      },
      "CONVERTER": {
        "TITLE": "Konvertovať",
        "STP_ONLY": "Podporované sú iba formáty súborov .stp a .step.",
        "ERROR_UPLOAD": "Pri nahrávaní súboru sa vyskytla chyba.",
        "DRAG": "Presuňte sem svoj súbor",
        "OR": "alebo",
        "CHOOSE": "Vyberte súbor",
        "CONVERT": "Konvertovať",
        "SUPPORTED": "Podporované formáty súborov:",
        "BACK": "Späť",
        "DOWNLOAD": "Stiahnuť",
        "ERROR_LOAD": "Pri načítavaní objektu sa vyskytla chyba."
      },
      "WHATSNEW": {
        "WHATSNEW_TITLE": "Čo je nové",
        "NO_UNREAD_UPDATE": "Žiadna neprečítaná aktualizácia"
      },
      "JOIN_MODAL": {
        "JOIN": "PRIPOJIŤ SA",
        "CALL": "ZAVOLAŤ",
        "CANCEL": "ZRUŠIŤ",
        "MIRROR_VIDEO": "Zrkadliť video",
        "PREFERRED_RESOLUTION": "Preferované rozlíšenie",
        "RESOLUTION_NOTE": "Poznámka: Ak vaše zariadenie nepodporuje požadované rozlíšenie, použije sa najbližšie najvyššie rozlíšenie.",
        "CAM_MIC_PERM_REQUIRED": "Vyžaduje sa povolenie pre fotoaparát a mikrofón",
        "CAM_MIC_PERM_DENIED": "Prístup ku kamere alebo mikrofónu bol zamietnutý",
        "CAM_MIC_CANT_ACCESS": "Nemáme prístup k vašej kamere alebo mikrofónu",
        "JOIN_CAM_OFF": "Pripojte sa s vypnutou kamerou",
        "JOIN_MIC_OFF": "Pripojte sa s vypnutým mikrofónom",
        "JOIN_CAM_MIC_OFF": "Pripojte sa s vypnutou kamerou a mikrofónom",
        "JOIN_NO_DEVICE": "Pripojte sa bez kamery a mikrofónu",
        "ALLOW_ACCESS": "V nastaveniach prehliadača musíte povoliť prístup ku kamere a mikrofónu (po udelení prístupu môžete kameru alebo mikrofón vypnúť).",
        "TRY_AGAIN": "Skúste to znova/obnovte stránku a po zobrazení výzvy prehliadača vyberte možnosť „Povoliť“."
      },
      "NO_DEVICE_MODAL": {
        "TITLE": "Nenašlo sa žiadne zariadenie",
        "JOIN_BODY": "K tomuto zariadeniu nie je pripojený žiadny mikrofón ani kamera. Ostatní používatelia vás prostredníctvom tohto zariadenia nebudú počuť ani vidieť. Chcete sa ešte pridať?",
        "CALL_BODY": "K tomuto zariadeniu nie je pripojený žiadny mikrofón ani kamera. Ostatní používatelia vás prostredníctvom tohto zariadenia nebudú počuť ani vidieť. Chcete ešte zavolať?",
        "CANCEL": "Zrušiť",
        "JOIN": "Napriek tomu sa pripojte",
        "CALL": "Napriek tomu zavolajte"
      },
      "AGREEMENT_MODAL": {
        "TITLE": "Formulár spracovania a zabezpečenia osobných dát",
        "REJECTION_BUTTON": "Odmietnuť",
        "AGREEMENT_BUTTON": "Súhlasiť"
      },
      "CHECK_AGREEMENT_MODAL": {
        "TITLE": "Zrušiť zmluvu?",
        "ERROR": "Došlo k chybe.",
        "STATEMENT": "Ak zmluvu neprijmete, nebudete sa môcť prihlásiť do systému.",
        "CANCEL_BUTTON": "Zrušiť",
        "PROCEED_BUTTON": "Pokračovať"
      },
      "JOIN_UNKNOWN_ERROR": "Pri pripájaní k miestnosti sa vyskytla chyba.",
      "JOIN_CONCURRENT_ERROR": "Dosiahli ste limit počtu súbežných používateľov účtu. Ak chcete získať ďalšie podrobnosti, kontaktujte svojho správcu.",
      "JOIN_EXPERT_CONCURRENT_ERROR": "Dosiahli ste limit počtu súbežných používateľov expertov. Ak chcete získať ďalšie podrobnosti, kontaktujte svojho správcu.",
      "NO_TRAINING_LICENSE": "Vyskytol sa problém s licenciou vašej školiacej miestnosti. Kontaktujte svojho správcu.",
      "TRAINING_LICENSE_EXPIRED": "Platnosť vašej licencie na školiacu miestnosť vypršala. Kontaktujte svojho správcu.",
      "ASK_TRAINING_HOST": "Pri pripájaní sa do školiacej miestnosti sa vyskytla chyba. Kontaktujte prosím hostiteľa.",
      "JOIN_CALL_IN_PROGRESS": "Vo vašej osobnej zasadacej miestnosti je ďalší hovor.",
      "NOT_SUPPORTED_TITLE": "Nekompatibilný prehliadač",
      "NOT_SUPPORTED_MESSAGE": "Váš prehliadač nie je kompatibilný. Použite Google Chrome, Mozilla Firefox, Safari alebo Microsoft Edge (verzia 79 alebo novšia).",
      "NO_IOS_MESSAGE": "Váš prehliadač nie je kompatibilný. Použite vzdialenú aplikáciu {{ appName }} alebo použite Safari.",
      "IOS_VERSION_MESSAGE": "Váš prehliadač nie je kompatibilný. Použite vzdialenú aplikáciu {{ appName }}.",
      "NOT_SUPPORTED_CLOSE": "Zavrieť",
      "IDLE_MODAL_TITLE": "Chyba",
      "IDLE_MODAL_MESSAGE": "Dlhšie ste neuskutočnili žiadnu transakciu.",
      "IDLE_MODAL_COUNT": "Budete odhlásený za {{ count }} sekúnd.",
      "IDLE_MODAL_OK": "Som späť",
      "ARCHIVE_PERMISSION_MODAL": {
        "TITLE": "Povoliť nahrávanie?",
        "MESSAGE": "Stretnutie v tejto miestnosti bude zaznamenané. Ak sa chcete pripojiť k tejto miestnosti, musíte povoliť nahrávanie videa.",
        "DENY": "Odmietnuť",
        "ALLOW": "Povoliť"
      }
    },
    "ARCHIVES": {
      "ARCHIVE_LIST": {
        "REFRESH": "Obnoviť",
        "LOADING": "Načítavajú sa záznamy videohovorov",
        "NO_ARCHIVE_MESSAGE": "Neexistuje žiadny záznam videohovoru",
        "NAME": "Názov",
        "CREATED_AT": "Vytvorené o",
        "STORAGE": "Skladovanie",
        "DURATION": "Trvanie",
        "ARCHIVES": "Záznamy videohovorov",
        "SIZE": "Veľkosť súboru",
        "STATUS": "Status",
        "AVAILABLE": "k dispozícii",
        "DISCONNECTED": "odpojený",
        "DELETED": "vymazaný",
        "EXPIRED": "platnosť vypršala",
        "WAITING": "čakanie",
        "FAILED": "nepodarilo",
        "DOWNLOAD": "Stiahnuť",
        "PLAY": "Prehrať",
        "DELETE": "Odstrániť",
        "DOWNLOAD_ARCHIVE": {
          "TITLE": "Stiahnite si záznam",
          "GENERATING": "Generuje sa adresa URL na stiahnutie",
          "GENERATED": "Vygenerovaná adresa URL na stiahnutie",
          "CANNOT_GENERATED": "Nedá sa vygenerovať URL na stiahnutie.",
          "DOWNLOAD": "Stiahnuť",
          "CLOSE": "Zavrieť"
        },
        "DELETE_ARCHIVE": {
          "TITLE": "Odstrániť záznam",
          "MESSAGE": "Záznam videohovoru bude vymazaný.",
          "CAUTION": "UPOZORNENIE: Tento záznam sa odstráni aj z vášho úložiska Azure.",
          "CANCEL": "Zrušiť",
          "DELETE": "Odstrániť"
        }
      }
    },
    "ROOMS": {
      "ROOM_DETAILS": {
        "BACK": "Späť",
        "TITLE_NEW": "Nová miestnosť",
        "TITLE_DETAILS": "Podrobnosti o miestnosti",
        "TITLE_EDIT": "Upraviť miestnosť",
        "ROOM_DISABLED": "IZBA ZAKÁZANÁ",
        "EDIT": "Upraviť",
        "RESET": "Resetovať",
        "REVERT": "Prejsť späť",
        "CANCEL": "Zrušiť",
        "ICON": "Ikona",
        "CHOOSE_FILE": "Vyberte súbor...",
        "ROOM_NAME": "Názov miestnosti",
        "TECHNICAL_DRAWING": "Technické kreslenie",
        "HAND_TOOLS": "Ručné nástroje",
        "FINISHED_PRODUCT": "Dokončený produkt",
        "VIDEO": "Video",
        "ROOM_NAME_REQUIRED": "Vyžaduje sa názov miestnosti",
        "ROOM_NAME_LENGTH": "Dĺžka názvu miestnosti musí byť medzi 1-60",
        "DESCRIPTION": "Popis",
        "DESCRIPTION_REQUIRED": "Vyžaduje sa popis",
        "DESCRIPTION_LENGTH": "Dĺžka popisu musí byť medzi 1-100",
        "USERS": "Používatelia",
        "SELECT_USERS": "Vybrať užívateľa",
        "SAVE": "ULOŽIŤ",
        "ROOM_UPDATED": "Miestnosť bola úspešne aktualizovaná.",
        "CANNOT_UPDATE": "Miestnosť sa nedá aktualizovať.",
        "ROOM_CREATED": "Miestnosť vytvorená.",
        "CANNOT_CREATE": "Nie je možné vytvoriť miestnosť.",
        "ALWAYS_ARCHIVE_ON": "Všetky miestnosti sa zaznamenávajú na váš účet. Môžete to zmeniť v nastaveniach.",
        "ARCHIVE_UNAVAILABLE": "Vaša licencia nemá funkciu nahrávania videohovorov.",
        "PEER_TO_PEER_NO_ARCHIVE": "Nahrávanie nie je dostupné pre miestnosti typu Peer-to-Peer.",
        "AUTO_ARCHIVE": "Automaticky nahrávať videohovory v tejto miestnosti",
        "ARCHIVE_PERMISSION_NEEDED": "Vyžadovať povolenie všetkých používateľov na spustenie nahrávania.",
        "PEER_TO_PEER": "Uskutočňujte videohovory Peer-to-Peer",
        "WHAT_IS_PEER_TO_PEER": "(Čo je to P2P)",
        "PEER_TO_PEER_UNAVAILABLE": "Vaša licencia nemá funkciu Peer-to-Peer.",
        "FULL_HD": "Vytvorte kvalitu streamovania/snímky FullHD na podporovaných mobilných zariadeniach",
        "FULL_HD_DISADVANTAGES": "Túto možnosť použite, keď je internetové pripojenie účastníkov stabilné. Upozorňujeme tiež, že to môže spotrebovať viac energie a dát na mobilných zariadeniach a spôsobiť problémy s pripojením.",
        "FULL_HD_UNAVAILABLE": "Vaša licencia nemá funkciu FullHD.",
        "TRAINING_ROOM_NO_PEER_TO_PEER": "Peer-to-Peer nie je k dispozícii pre akadémie.",
        "TRAINING_ROOM": "Akadémia",
        "TRAINING_LICENSE": "Licencia na akadémiu",
        "TRAINING_LICENSE_REQUIRED": "Vyžaduje sa licencia na akadémiu.",
        "TRAINING_MASTER": "Hostiteľ akadémie",
        "TRAINING_MASTER_REQUIRED": "Pre akademické miestnosti sa vyžaduje hostiteľ.",
        "TRAINING_ROOM_UNAVAILABLE": "Vaša licencia nemá akademické funkcie.",
        "WHAT_IS_P2P": {
          "TITLE": "Čo je to Peer-to-Peer",
          "BETWEEN_CLIENTS": "Klienti posielajú audio-video streamy priamo medzi sebou.",
          "REDUCED_LATENCY": "Možnosť Peer-to-Peer ponúka výhodu zníženej latencie.",
          "ARCHIVE_UNAVAILABLE": "Peer-to-Peer reláciu nie je možné zaznamenať, pretože spojenie je vytvorené priamo medzi partnermi zapojenými do relácie.",
          "CLOSE": "Zavrieť"
        },
        "ENABLE_ROOM": "POVOLIŤ MIESTNOSŤ",
        "DISABLE_ROOM": "ZAKÁZAŤ MIESTNOSŤ",
        "TOGGLE_ROOM_MODAL": {
          "TITLE_ENABLE": "Povoliť miestnosť?",
          "TITLE_DISABLE": "Zakázať miestnosť?",
          "MESSAGE_ENABLE": "Naozaj chcete povoliť miestnosť <strong>{{name}}</strong>?",
          "MESSAGE_DISABLE": "Naozaj chcete zakázať miestnosť <strong>{{name}}</strong>?",
          "CANCEL": "Zrušiť",
          "ENABLE": "Povoliť",
          "DISABLE": "Zakázať",
          "ENABLED": "Miestnosť povolená.",
          "DISABLED": "Zakázaná miestnosť",
          "ERROR": "Stav miestnosti nie je možné zmeniť."
        },
        "DELETE_ROOM": "VYMAZAŤ MIESTNOSŤ",
        "DELETE_ROOM_MODAL": {
          "TITLE": "Odstrániť miestnosť?",
          "MESSAGE": "Naozaj chcete odstrániť miestnosť <strong>{{name}}</strong>?",
          "CANCEL": "Zrušiť",
          "DELETE": "Odstrániť",
          "DELETED": "Miestnosť bola odstránená.",
          "ERROR": "Miestnosť nie je možné odstrániť."
        },
        "CHANGE_AUTO_ARCHIVE_MODAL": {
          "TITLE": "Uložiť zmeny miestnosti",
          "MESSAGE_START": "Zmeny zapnuté",
          "AUTO_ARCHIVE": "automatický záznam videohovoru",
          "AND": " a",
          "PEER_TO_PEER": "Peer-to-Peer",
          "MESSAGE_END": " sa použije na nasledujúce relácie.",
          "CAUTION": "UPOZORNENIE: Záznam nie je dostupný, keď je zapnutá funkcia Peer-to-Peer.",
          "TRAINING_CAUTION": "Kým sa táto miestnosť zmení na akadémickú (alebo naopak), všetci v tejto miestnosti budú vyhodení.",
          "CANCEL": "Zrušiť",
          "SAVE": "Uložiť"
        }
      },
      "ROOM_LIST": {
        "TITLE": "Miestnosti",
        "NO_ROOM_MESSAGE": "Zoznam miestností je prázdny",
        "NEW_ROOM": "Nová miestnosť",
        "ICON": "Ikona",
        "ROOM_NAME": "Názov miestnosti",
        "DISABLED": "zakázaný",
        "USERS": "Používatelia",
        "ACTIVE": "Aktívne",
        "PASSIVE": "Pasívne",
        "DETAILS": "Podrobnosti",
        "EDIT": "Upraviť",
        "DELETE": "Odstrániť",
        "DISABLE": "Zakázať",
        "ENABLE": "Povoliť",
        "ROOM_LIMIT_REACHED": "Dosiahli ste maximálny limit miestnosti {{ appName }}.",
        "GUEST": "Hosť",
        "ALL_USERS": "Všetci používatelia"
      }
    },
    "SESSIONS": {
      "SESSION_DETAILS": {
        "TITLE": "Podrobnosti relácie",
        "BACK": "Späť",
        "PARTICIPANTS": "Účastníci",
        "CREATED_AT": "Vytvorené na:",
        "DURATION": "Trvanie:",
        "GUEST": "(Hosť)",
        "ATTACHED_TICKET": "Priložený tiket",
        "ATTACH_TO_TICKET": "Pripojte k tiketu",
        "ATTACH_SESSION_TO_TICKET": "Pripojte reláciu k tiketu",
        "CLOSE": "Zavrieť",
        "ATTACH": "Priložiť",
        "APPLY_FILTERS": "Použiť filtre",
        "SESSIONS": "Relácie",
        "SESSION_COUNT": "Počet relácií",
        "TOTAL_DURATION": "Celkové trvanie",
        "EXPORT": "Export",
        "DATE": "Dátum",
        "SESSION_EXPORT": {
          "TITLE": "Export relácie",
          "MESSAGE": "Export relácie bude zahŕňať všetky chatové správy, snímky, záznamy videohovorov a súbory zdieľané v rámci relácie.",
          "SEND": "ODOSLAŤ",
          "EXPORT_SUCCEEDED": "Export relácie sa odošle po skončení relácie.",
          "EXPORT_FAILED": "Nastala chyba.",
          "WARNING": "Po každej e-mailovej adrese stlačte Enter."
        },
        "SESSION_CHAT": {
          "COLLABORATE": "Spolupracovať",
          "CLOSE_COLLABORATION": "Uzavrieť spoluprácu",
          "DOWNLOAD": "Stiahnuť",
          "DELETE": "Odstrániť",
          "DETAILS": "Podrobnosti",
          "FILE_DELETED": "Súbor bol odstránený",
          "JOIN_ROOM": "{{ owner_info }} sa pripojil k miestnosti.",
          "LEAVE_ROOM": "{{ owner_info }} opustil miestnosť.",
          "REACTION": "{{ owner_info }} odoslal reakciu",
          "REQUEST_SCREENSHOT": "{{ owner_info }} vyžiadal snímku.",
          "SHARE_SCREENSHOT": "{{ owner_info }} zdieľa snímku.",
          "SHARE_IMAGE": "{{ owner_info }} zdieľa obrázok.",
          "SHARE_PDF": "{{ owner_info }} zdieľa súbor pdf.",
          "SHARE_OTHER": "{{ owner_info }} zdieľa súbor.",
          "SHARE_OBJECT": "{{ owner_info }} zdieľal 3D objekt.",
          "COLLABORATED": "{{ owner_info }} začal spoluprácu."
        },
        "FILES": "Súbory",
        "CHAT": "Chat"
      },
      "SESSION_LIST": {
        "ALL_SESSIONS": "Relácie",
        "LAST_SESSIONS": "Posledné relácie",
        "ROOM_SESSIONS": "Posledné 3 relácie v {{room}}",
        "LOADING": "Načítava",
        "NO_SESSION_MESSAGE": "Zoznam relácií je prázdny",
        "DATE": "Dátum",
        "ROOM_NAME": "Názov miestnosti",
        "PARTICIPANTS": "Účastníci",
        "STATUS": "Postavenie",
        "DURATION": "Trvanie",
        "GUEST": "(Hosť)",
        "ON_GOING": "Prebieha",
        "ENDED": "Ukončený",
        "START_END": "Začiatok Koniec",
        "ALL_ROOMS": "Všetky miestnosti",
        "ALL_USERS": "Všetci používatelia",
        "ALL_LABELS": "Všetky štítky"
      },
      "SESSION_FILES": {
        "DOWNLOAD_STARTED_SOON": "Sťahovanie bude čoskoro spustené.",
        "DOWNLOAD_FAILED": "Sťahovanie zlyhalo.",
        "NO_FILE_IS_ADDED": "V tejto relácii nie je pridaný žiadny súbor ani s ním nespolupracuje."
      }
    },
    "USERS": {
      "USER_DETAILS": {
        "BACK": "späť",
        "TITLE_NEW": "Nový užívateľ",
        "TITLE_DETAILS": "Podrobnosti o používateľovi",
        "TITLE_EDIT": "Upraviť používateľa",
        "USER_DISABLED": "UŽÍVATEĽ ZAKÁZANÝ",
        "EDIT": "Upraviť",
        "RESET": "Resetovať",
        "REVERT": "Prejsť späť",
        "CANCEL": "Zrušiť",
        "USER_ROLE": "Rola",
        "ADMIN": "Administrátor",
        "COADMIN": "Spolusprávca",
        "USER": "Používateľ",
        "SUBSCRIBER": "Predplatiteľ",
        "EXPERT": "Expert",
        "NAME": "Názov",
        "ROLE": "Rola",
        "PERMISSIONS": "Povolenia",
        "CLOSE": "Zavrieť",
        "REACHED_MAX_NUMBER_EXPERT_LIMIT": "Dosiahli ste maximálny počet expertov.",
        "SINGLE_SIGN_ON_CODE": "Kód jednotného prihlásenia",
        "GENERATING": "Generovanie",
        "GENERATE_CODE": "Generovať kód",
        "CLICK_CODE_FOR_COPY": "Kliknutím na kód ho skopírujete",
        "ARCHIVE_UNAVAILABLE": "Vaša licencia nemá funkciu nahrávania videohovorov.",
        "ALLOW_ARCHIVING": "Povolenie spustiť/zastaviť nahrávanie videohovorov",
        "PERSONAL_ROOM_SETTINGS": "Osobné nastavenia miestnosti (počas hovoru)",
        "CALL_ARCHIVE_PERM_NEEDED": "Vyžadovať povolenie všetkých používateľov na spustenie nahrávania.",
        "CALLING_UNAVAILABLE": "Vaša licencia nemá funkciu volania.",
        "ALLOW_CALLING": "Povolenie uskutočňovať hovory",
        "ALLOW_SEEING_ALL_USERS": "Povolenie na zobrazenie zoznamu používateľov",
        "JOIN_LINK_UNAVAILABLE": "Vaša licencia nemá funkciu hosťovského prístupu.",
        "ALLOW_JOIN_LINK": "Povolenie na vytvorenie „prístupu pre hostí“",
        "PERMISSION_TO_SEE_USERS_IN_SAME_ROOM": "Povolenie vidieť používateľov v rovnakej miestnosti",
        "PERMISSION_TO_SEE_USERS_ALL": "Povolenie na zobrazenie všetkých používateľov",
        "NAME_REQUIRED": "Meno vyžadované",
        "NAME_START_WITH": "Začína alfanumerickým.",
        "NAME_CONTAINS": "Môže obsahovať alfanumerické a špeciálne znaky -._ (medzera)",
        "NAME_LENGTH": "Dĺžka názvu musí byť medzi 1-60",
        "USERNAME": "Používateľské meno",
        "USERNAME_REQUIRED": "Vyžaduje sa používateľské meno",
        "USERNAME_ALREADY_TAKEN": "Už prevzaté",
        "USERNAME_CONTAINS": "Vyberte si používateľské meno, ktoré obsahuje iba alfanumerické znaky, podčiarkovník ( _ ) a spojovník ( - )",
        "USERNAME_LENGTH": "Dĺžka používateľského mena musí byť medzi 1-30",
        "EMAIL": "Email",
        "EMAIL_REQUIRED": "E-mail sa vyžaduje, keď je povolené dvojfaktorové overenie.",
        "EMAIL_INVALID": "Neplatný email",
        "PASSWORD": "Heslo",
        "PASSWORD_REQUIRED": "Vyžaduje sa heslo",
        "PASSWORD_MINLENGTH": "Dĺžka hesla musí byť medzi 6-30",
        "CONFIRM_PASSWORD": "Potvrďte heslo",
        "CONFIRM_PASSWORD_NOTMATCH": "Heslá sa nezhodujú.",
        "DEFAULT_ROOM": "Predvolená miestnosť",
        "ROOMS": "Miestnosti",
        "SELECT_ROOMS": "Vyberte položku Miestnosti",
        "SAVE": "ULOŽIŤ",
        "CALL_INFO_MODAL": {
          "TITLE": "Povolenie hovoru?",
          "MESSAGE": "Používatelia s povolením na hovor môžu pristupovať k zoznamu používateľov a uskutočňovať hovory bez toho, aby museli predtým vytvárať miestnosť.",
          "CLOSE": "Zavrieť"
        },
        "QR_CODE_TITLE": "QR kód",
        "QR_CODE_LOADING": "QR kód sa načítava",
        "QR_ENABLE_FIRST": "Používateľ je zakázaný",
        "NO_QR_CODE": "Žiadny QR kód",
        "GENERATE_QR": "Vygenerujte QR kód",
        "QR_MESSAGE": "Pomocou tohto QR kódu môžete autentifikovať inteligentné okuliare a mobilné telefóny.",
        "REGENERATE": "Regenerovať",
        "REMOVE": "Odstrániť",
        "DOWNLOAD": "Stiahnuť",
        "CHANGE_PASSWORD_TITLE": "Zmeniť heslo",
        "CHANGE_PASSWORD": "ZMENIŤ HESLO",
        "CREATE_NEW_PASSWORD": "Požiadavky na heslo",
        "UPPERCASE": "Veľké písmená",
        "LOWERCASE": "Malé písmenami",
        "NUMBER": "Číslo",
        "SPECIAL": "Špeciálne",
        "NOT_WHITESPACE": "Vaše heslo nesmie obsahovať medzery",
        "AT_LEAST_PASSWORD_LENGTH": "Minimálny počet znakov: {{ passwordlength }}",
        "DO_NOT_CREATE_SIMPLE": "Nevytvárajte slabé heslá ako „123456“",
        "CHANGE_PASSWORD_MODAL": {
          "TITLE": "Zmeniť heslo?",
          "MESSAGE": "Používateľské heslo bude zmenené.",
          "CAUTION": "UPOZORNENIE: Upozorňujeme, že aktuálny používateľský QR kód bude vymazaný.",
          "CANCEL": "Zrušiť",
          "CHANGE": "Zmeniť"
        },
        "PASSWORD_CHANGED": "Heslo zmenené.",
        "CANNOT_CHANGE": "Nie je možné zmeniť heslo.",
        "QR_REMOVE_TITLE": "Odstrániť QR kód?",
        "QR_REMOVE_MESSAGE": "QR kód bude vymazaný.",
        "QR_REMOVE_NO": "Zrušiť",
        "QR_REMOVE_YES": "Odstrániť",
        "QR_REGENERATE_TITLE": "Regenerovať?",
        "QR_REGENERATE_MESSAGE": "Predchádzajúci QR kód bude zakázaný.",
        "QR_REGENERATE_NO": "Zrušiť",
        "QR_REGENERATE_YES": "Regenerovať",
        "QR_REMOVED": "QR kód bol odstránený.",
        "CANNOT_REMOVE": "Nie je možné odstrániť QR kód.",
        "QR_GENERATED": "Vygenerovaný QR kód.",
        "CANNOT_GENERATE": "Nedá sa vygenerovať QR kód.",
        "USER_UPDATED": "Používateľ bol úspešne aktualizovaný.",
        "CANNOT_UPDATE": "Používateľa nie je možné aktualizovať.",
        "USER_CREATED": "Používateľ bol vytvorený.",
        "CANNOT_CREATE": "Nie je možné vytvoriť používateľa.",
        "UPDATE_USER_MODAL": {
          "TITLE": "Aplikovať zmeny?",
          "USENAME_MESSAGE": "Používateľské meno bude zmenené.",
          "USENAME_CAUTION": "UPOZORNENIE: Upozorňujeme, že aktuálny používateľský QR kód bude vymazaný.",
          "EMAIL_MESSAGE": "E-mail správcu bude odstránený.",
          "EMAIL_CAUTION": "UPOZORNENIE: Už nebudete dostávať týždenné správy o používaní. Ostatní príjemcovia budú tiež odstránení.",
          "CANCEL": "Zrušiť",
          "CHANGE": "Zmeniť"
        },
        "WITHOUT_ROOM_MODAL": {
          "TITLE": "Vytvoriť používateľa bez miestnosti?",
          "MESSAGE": "Používateľ bude vytvorený bez akejkoľvek miestnosti.",
          "CANCEL": "Zrušiť",
          "CREATE": "Vytvoriť"
        },
        "DISABLE_USER": "ZAKÁZAŤ POUŽÍVATEĽA",
        "ENABLE_USER": "POVOLIŤ POUŽÍVATEĽA",
        "TOGGLE_USER_MODAL": {
          "TITLE_ENABLE": "Povoliť používateľa?",
          "TITLE_DISABLE": "Zakázať používateľa?",
          "MESSAGE_ENABLE": "Naozaj chcete povoliť používateľa <strong>{{name}}</strong>?",
          "MESSAGE_DISABLE": "Naozaj chcete zakázať používateľa <strong>{{name}}</strong>?",
          "CANCEL": "Zrušiť",
          "ENABLE": "Povoliť",
          "DISABLE": "Zakázať",
          "ENABLED": "Používateľ povolené.",
          "DISABLED": "Používateľ je zakázaný.",
          "ERROR": "Stav používateľa nie je možné zmeniť."
        },
        "DELETE_USER": "VYMAZAŤ POUŽÍVATEĽA",
        "DELETE_USER_MODAL": {
          "TITLE": "Odstrániť používateľa?",
          "MESSAGE": "Naozaj chcete odstrániť používateľa <strong>{{name}}</strong>?",
          "CAUTION": "POZOR: Toto sa nedá vrátiť späť!",
          "CANCEL": "Zrušiť",
          "DELETE": "Odstrániť",
          "DELETED": "Používateľ bol odstránený.",
          "ERROR": "Používateľa nie je možné vymazať."
        },
        "LABEL": "Označenie",
        "CREATE_NEW_LABELS": "Vytvor nový"
      },
      "USER_LIST": {
        "TITLE": "Používatelia",
        "NO_USER_MESSAGE": "Zoznam používateľov je prázdny.",
        "NEW_USER": "Nový užívateľ",
        "NAME": "Názov",
        "DISABLED": "zakázaný",
        "USERNAME": "Používateľské meno",
        "ROOMS": "Miestnosti",
        "ROLE": "Rola",
        "DETAILS": "Podrobnosti",
        "EDIT": "Upraviť",
        "DELETE": "Odstrániť",
        "DISABLE": "Zakázať",
        "ENABLE": "Povoliť",
        "EXCEL": "Excel",
        "IMPORT_FILE": "Importovať súbor",
        "IMPORT_FROM": "Importovať používateľov",
        "ADMIN": "Administrátor",
        "COADMIN": "Spolusprávca",
        "USER": "Používateľ",
        "EXPERT": "Expert",
        "SUBSCRIBER": "Predplatiteľ",
        "IMPORT_FAILED": "Import zlyhal",
        "UPLOAD_SUCCEEDED": "Nahrávanie bolo úspešné",
        "SAME_USERNAME": "Váš excelový zoznam obsahuje používateľov s rovnakým používateľským menom. Skontrolujte svoje údaje v Exceli.",
        "SAME_USERNAME_PRE_REGISTERED": "Pokúšate sa nahrať používateľov s rovnakým používateľským menom, aké ste predtým zaregistrovali. Znova skontrolujte svoje údaje.",
        "FILL_ALL_NECESSARY": "Vyplňte všetky potrebné polia",
        "EXPERT_LIMIT_EXCEEDED": "Odborný limit bude prekročený. Skontrolujte svoje údaje v Exceli.",
        "PLEASE_DONT_USE_DOTS_FOR_USERNAME": "Prosím, nepoužívajte bodky ako užívateľské meno",
        "WRONG_BOOLEAN_FORMAT": "Použili ste nesprávny booleovský formát, skontrolujte svoje údaje.",
        "SUCCESSFULLY_ADDED": "Používateľ bol úspešne pridaný.",
        "USER_COULD_NOT_BE_ADDED": "Používateľa nebolo možné pridať.",
        "CORRECT_BOOLEAN": "Zadajte správnu boolovskú hodnotu",
        "IMPORT_USERS": "Importovať používateľov",
        "PLEASE_WAIT": "Prosím čakajte. Môže to trvať pár minút.",
        "PROBLEMS_OCCURRED": "Vyskytli sa nejaké problémy.",
        "UPLOAD_FILE": "Nahrajť súbor",
        "DOWNLOAD_SAMPLE": "Stiahnite si vzorový súbor Excel na zaznamenanie údajov.",
        "SAMPLE_FORMAT": "Aby boli nahrávky úspešné, neupravujte vzorový formát.",
        "CLICK_TO_DOWNLOAD": "Stiahnite si vzorový súbor Excel",
        "ALLOWED_TYPES": "Povolené typy súborov: xlsx",
        "SUCCESSFULLY_REGISTERED": "Používatelia sú úspešne zaregistrovaní do systému.",
        "CHOOSE_A_FILE": "Vyberte súbor",
        "LIST_OF_THE_USERS": "Zoznam používateľov, ktorí boli identifikovaní ako dvojníci",
        "CANCEL": "Zrušiť",
        "EMAIL": "Email",
        "PASSWORD": "Heslo",
        "PERMISSIONS": "Povolenia",
        "CLOSE": "Zavrieť"
      },
      "ALL_ROOMS": "Všetky miestnosti",
      "ALL_ROLES": "Všetky roly",
      "NAME_USERNAME": "Meno alebo Používateľské meno"
    },
    "SETTINGS": {
      "ARCHIVE": {
        "TITLE": "Nastavenia nahrávania videohovorov",
        "ROOMS": "Miestnosť",
        "RECORD_STATUS": "Stav záznamu",
        "AUTO": "Auto",
        "P2P": "P2P",
        "MANUAL": "Manuálny",
        "AUTO_RECORD": "Automaticky nahrávať všetky miestnosti",
        "CHANGE_INDIVIDUALLY": "Správanie záznamu miestnosti môžete zmeniť na stránkach jednotlivých miestností.",
        "NO_ARCHIVE": "Vaša licencia nemá funkciu nahrávania videohovorov.",
        "SAVE": "ULOŽIŤ"
      },
      "EMAIL_RECIPIENTS": {
        "TITLE": "Zoznam príjemcov týždenného prehľadu používania",
        "MESSAGE": "Môžete pridať ďalšie e-mailové adresy, aby ste dostávali týždenný prehľad používania z aplikácie {{ appName }}",
        "PLACEHOLDER": "Pridať nové",
        "SECONDARY_PLACEHOLDER": "Vložte emailovú adresu",
        "ADMIN_MAIL_FIRST": "Najprv pridajte e-mailovú adresu správcu z ponuky používateľov",
        "INVALID_EMAIL": "Neplatný formát e-mailu.",
        "SAVE": "ULOŽIŤ",
        "CANNOT_CHANGE": "Zoznam príjemcov nie je možné aktualizovať.",
        "WARNING": "Po každej e-mailovej adrese stlačte Enter."
      },
      "TWO_FACTOR_AUTH": {
        "TITLE": "Dvojfaktorová autentifikácia",
        "ADMIN_2FA": "Dvojfaktorová autentifikácia na paneli správcu",
        "ENABLE": "Povoliť",
        "DISABLE": "Zakázať",
        "TWO_FACTOR_UNAVAILABLE": "Vaša licencia neobsahuje funkciu Two Factor Authentication."
      },
      "TIMEZONE": {
        "TITLE": "Zmeniť časové pásmo",
        "SAVE": "ULOŽIŤ",
        "CANNOT_CHANGE": "Časové pásmo nie je možné aktualizovať."
      },
      "DEFAULT_WORK_GROUPS": {
        "TITLE": "Predvolené pracovné skupiny",
        "MESSAGE": "Vyberte pracovné skupiny, do ktorých sa noví používatelia priradia predvolene.",
        "SELECT": "Vyberte pracovné skupiny",
        "NO_WORK_GROUP": "V tomto konte ešte nie je žiadna pracovná skupina.",
        "SAVE": "ULOŽIŤ",
        "SAVED": "Predvolené pracovné skupiny sú aktualizované.",
        "CANNOT_CHANGE": "Predvolené pracovné skupiny nie je možné aktualizovať.",
        "STALE_SELECTION": "Jedna z vybraných pracovných skupín už neexistuje. Obnovte stránku a skúste to znova."
      },
      "VOICE_COMMANDS": {
        "TITLE": "Hlasové príkazy",
        "NEW_COMMAND": "Nový príkaz",
        "LOADING": "Načítava",
        "NO_COMMAND": "Zoznam príkazov je prázdny",
        "COMMAND": "Príkaz",
        "TRANSLATION": "Preklad",
        "LANGUAGE": "Jazyk",
        "UNAVAILABLE": "Vaša licencia neobsahuje funkciu Hlasové príkazy.",
        "ADD_MODAL": {
          "TITLE": "Pridať nový príkaz",
          "CLOSE": "Zavrieť",
          "ADD": "Pridať"
        }
      },
      "AZURE_AD": {
        "CANCEL": "Zrušiť",
        "ADD": "Pridať",
        "REMOVE": "Odstrániť",
        "COPY": "Kopírovať",
        "AZURE_AD_INTEGRATION": "AZURE INTEGRÁCIA REKLÁM",
        "SINGLE_SIGN_ON": "Jednotné prihlásenie",
        "CONFIGURE_SAML": "Odtiaľto môžete nakonfigurovať jednotné prihlásenie založené na SAML.",
        "ADD_SAML_CONFIGURATION": "Pridajte konfiguráciu SAML",
        "REMOVE_SAML_CONFIGURATION": "Odstráňte konfiguráciu SAML",
        "INFORMATION": "Informácie požadované službou Azure Active Directory",
        "INFORMATION_VSIGHT": "Informácie požadované VSight",
        "IDENTIFIER": "Identifikátor (ID entity)",
        "REPLY_URL": "Adresa URL odpovede",
        "REPLY_URL2": "Adresa URL odpovede 2",
        "REPLY_URL3": "Adresa URL odpovede 3",
        "USER_PROVISIONING": "Poskytovanie používateľov",
        "SCIM_USER_PROVISIONING": "Tu môžete nakonfigurovať poskytovanie používateľov na základe SCIM.",
        "ADD_SCIM_CONFIGURATION": "Pridať konfiguráciu SCIM",
        "REMOVE_SCIM_CONFIGURATION": "Odstráňte konfiguráciu SCIM",
        "INFO": "Informácie požadované službou Azure Active Directory",
        "ENDPOINT": "Koncový bod SCIM (webová adresa nájomcu)",
        "ADD_SAML": "Pridajte konfiguráciu SAML",
        "SSO": "Adresa URL jednotného prihlásenia poskytovateľa identity",
        "SSO_URL_REQUIRED": "Vyžaduje sa webová adresa SSO.",
        "CERTIFICATE": "Verejný certifikát x509",
        "CERTIFICATE_REQUIED": "Vyžaduje sa certifikát.",
        "GENERATE_TOKEN_FOR_SCIM": "Generovať token pre SCIM",
        "REMOVE_SAML_CONFIGURATION_QUESTION": "Naozaj chcete odstrániť konfiguráciu SAML?",
        "REMOVE_SCIM_CONFIGURATION_QUESTION": "Naozaj chcete odstrániť konfiguráciu SCIM?"
      },
      "ENABLE_SYSTEM_EMAIL": {
        "CONFIGURE_CUSTOM_SERVICE_EMAIL": "Nakonfigurujte vlastný servisný e-mail",
        "SENDER_NAME": "Meno odosielateľa",
        "SENDER_NAME_IS_REQUIRED": "Vyžaduje sa meno odosielateľa.",
        "SENDER_HOST": "Hostiteľ odosielateľa",
        "SENDER_HOST_IS_REQUIRED": "Vyžaduje sa hostiteľ odosielateľa.",
        "SENDER_PORT": "Port odosielateľa",
        "SENDER_EMAIL": "E-mail odosielateľa",
        "SENDER_EMAIL_IS_REQUIRED": "Vyžaduje sa e-mail odosielateľa.",
        "USER": "Používateľ",
        "USER_IS_REQUIRED": "Vyžaduje sa používateľ.",
        "EMAIL_FORMAT_IS_INVALID": "Neplatný formát e-mailu.",
        "PASSWORD": "Heslo",
        "PASSWORD_IS_REQUIRED": "Vyžaduje sa heslo.",
        "CANCEL": "Zrušiť",
        "VERIFY": "Overiť",
        "VERIFY_CUSTOM_SERVICE_EMAIL": "Overte vlastný servisný e-mail",
        "SEND_VERIFICATION_CODE": "Poslali sme vám e-mail s overovacím kódom."
      },
      "DISABLE_SYSTEM_EMAIL": {
        "DISABLE_CUSTOM_SERVICE_EMAIL": "Zakázať vlastný servisný e-mail",
        "SYSTEM_EMAILS_SEND": "Systémové e-maily sa budú odosielať z predvoleného e-mailu služby VSight.",
        "CANCEL": "Zrušiť",
        "DISABLE": "Zakázať"
      },
      "ALWAYS_ARCHIVE": {
        "AUTO_RECORD": "Automaticky nahrávať všetky miestnosti",
        "CHANGE_INDIVIDUALLY": "Individuálne zmeniť správanie pri nahrávaní miestnosti",
        "AUTO_MESSAGE": "Všetky relácie miestnosti sa budú automaticky zaznamenávať.",
        "INDIVIDUAL_MESSAGE": "Správanie záznamu miestnosti môžete zmeniť na stránkach jednotlivých miestností.",
        "WARNING": "Zmeny v automatickom zázname videohovoru sa použijú na nasledujúce relácie.",
        "CAUTION": "UPOZORNENIE: Toto je miestnosť typu Peer-to-Peer. Záznam pre tieto miestnosti nie je k dispozícii.",
        "CANCEL": "Zrušiť",
        "PROCEED": "Pokračovať",
        "CHANGE": "Zmeniť individuálne"
      },
      "WHAT_IS_P2P": {
        "TITLE": "Čo je to Peer-to-Peer",
        "BETWEEN_CLIENTS": "Klienti posielajú audio-video streamy priamo medzi sebou.",
        "REDUCED_LATENCY": "Možnosť Peer-to-Peer ponúka výhodu zníženej latencie.",
        "ARCHIVE_UNAVAILABLE": "Relácie typu peer-to-peer nie je možné zaznamenať, pretože spojenie je vytvorené priamo medzi partnermi zapojenými do relácie.",
        "CLOSE": "Zavrieť"
      },
      "ADD_EMAIL": {
        "TITLE": "Vyžaduje sa e-mail",
        "ADMIN": "Musíte pridať všetky e-mailové adresy správcov a spolusprávcov zo stránok používateľov.",
        "ALL": "Musíte pridať všetky e-mailové adresy zo stránok používateľov.",
        "GO_TO_PROFILE": "Prejdite na profil",
        "USER_MAILS": "Pridajte e-mailové adresy nasledujúcich používateľov:",
        "CLOSE": "Zavrieť"
      },
      "TWO_FACTOR_MODAL": {
        "ENABLE_ADMIN": "Povoliť dvojfaktorové overenie správcu",
        "DISABLE_ADMIN": "Zakázať dvojfaktorové overenie správcu",
        "ENABLE_ALL": "Povoliť všetkým používateľom dvojfaktorové overenie",
        "DISABLE_ALL": "Zakázať všetkých používateľov okrem dvojfaktorovej autentizácie správcu",
        "VERIFICATION_SENDED": "Pošleme vám e-mail s overovacím kódom.",
        "VERIFICATION_CODE": "Overovací kód",
        "CANCEL": "Zrušiť",
        "SEND_CODE": "Odoslať kód",
        "PROCEED": "Pokračovať"
      },
      "WHITELABEL_SETTINGS": {
        "TITLE": "Nastavenia bieleho štítku",
        "SYSTEM_EMAIL_TITLE": "Prispôsobte si systémový e-mail",
        "SYSTEM_EMAIL_MESSAGE": "Tu môžete nakonfigurovať svoj servisný e-mail.",
        "ENABLE": "Povoliť",
        "DISABLE": "Zakázať"
      },
      "WEBHOOKS": {
        "TITLE": "Webhooks",
        "NEW_WEBHOOK": "Pridať Webhook",
        "NO_WEBHOOK": "Zoznam webhook je prázdny",
        "EVENT": "Udalosť",
        "URL": "URL",
        "SAVE": "ULOŽIŤ",
        "REMOVE": "Odstrániť",
        "ERROR": "Nastala chyba.",
        "API_ERROR": "Testovacia notifikácia zlyhala.",
        "ADD_WEBHOOK_MODAL": {
          "TITLE": "Pridať Webhook",
          "PLACEHOLDER": "https://",
          "WARNING": "Počas pridávania nového webhook sa odošle testovacie upozornenie.",
          "CANCEL": "Zrušiť",
          "ADD": "Pridať"
        },
        "REMOVE_WEBHOOK_MODAL": {
          "TITLE": "Odstrániť Webhook?",
          "MESSAGE": "Naozaj chcete odstrániť webhook?",
          "CANCEL": "Zrušiť",
          "REMOVE": "Odstrániť"
        }
      },
      "PASSWORD_POLICY": {
        "TITLE": "Zásady hesiel",
        "SPECIFY_RULE": "Zadajte pravidlá hesiel svojich používateľov",
        "MIN_LENGTH": "Minimálna dĺžka hesla",
        "FOLLOWING_CRITERIAS": "Spĺňa nasledujúce kritériá",
        "SAVE": "ULOŽIŤ",
        "SUCCESS": "Vaše nastavenia hesla boli zmenené",
        "ERROR": "Nastala chyba.",
        "UPPERCASE": "Veľké písmená",
        "LOWERCASE": "Malé písmená",
        "NUMBER": "Číslo",
        "SPECIAL": "Špeciálne"
      },
      "CONTACT_INFO": {
        "TITLE": "Kontaktné informácie",
        "NEW": "Nový kontakt",
        "CONTACT": "Kontakt",
        "DEPARTMENT": "Oddelenie",
        "NAME": "Názov",
        "EMAIL": "Email",
        "PHONE": "Telefónne číslo",
        "DELETE": "Odstrániť",
        "EDIT": "Upraviť",
        "CANCEL": "Zrušiť",
        "REVERT": "Prejsť späť",
        "DEP_REQ": "Vyžaduje sa oddelenie",
        "NAME_REQ": "Meno vyžadované",
        "EMAIL_REQ": "Vyžaduje sa e-mail",
        "INVALID_EMAIL": "Neplatný email",
        "SAVE": "ULOŽIŤ",
        "SUCCESS": "Kontaktné informácie boli úspešne aktualizované.",
        "FAILED": "Aktualizácia kontaktných informácií zlyhala."
      },
      "SYS_REQ": {
        "TITLE": "Hardvérové a softvérové požiadavky",
        "ANDROID_TITLE": "Požiadavky na zariadenia so systémom Android",
        "IOS_TITLE": "Požiadavky na zariadenia so systémom iOS",
        "NETWORK_TITLE": "Sieťové požiadavky",
        "BROWSERS_TITLE": "Podporované prehliadače",
        "ANDROID_VERSION": "Android 5.0 alebo novší",
        "ANDROID_RAM": "1,5 GB RAM alebo viac",
        "ANDROID_CORE_SPEED": "Maximálna rýchlosť jadra 1,5 GHz alebo vyššia",
        "ANDROID_ARCORE": "Ak chcete používať AR+, vaše zariadenie musí podporovať ARCore. Zariadenia, ktoré podporujú ARCore, nájdete na tejto stránke:",
        "ANDROID_ARCORE_DEVICE": "Zariadenia s podporou ARCore",
        "IOS_VERSION": "iOS 13 alebo novší",
        "IOS_IPHONE": "iPhone 8 alebo novší",
        "IOS_IPAD": "iPad Pro 2017 alebo novší",
        "IOS_ARKIT": "Ak chcete používať AR+, vaše zariadenie musí podporovať ARkit. Zariadenia, ktoré podporujú ARkit, nájdete na tejto stránke:",
        "IOS_ARKIT_DEVICE": "Zariadenia s podporou ARkit",
        "NETWORK_BODY": "Na udržanie stabilného pripojenia videa je potrebné internetové pripojenie s rýchlosťou sťahovania a odosielania 350 kb/s, ale na dosiahnutie lepších výsledkov sa odporúča rýchlosť sťahovania a odosielania 1 Mb/s s nízkou latenciou.",
        "CHROME": "Google Chrome",
        "FIREFOX": "Mozilla Firefox",
        "SAFARI": "Safari (12 alebo novší)",
        "EDGE": "Microsoft Edge (79 alebo novší)"
      }
    },
    "STORAGE": {
      "TITLE": "Ukladanie záznamov videohovorov",
      "CONNECT_AZURE": "Pripojte sa k Azure",
      "DISCONNECT_AZURE": "Odpojte Azure",
      "SHARED_DEDICATED_SIZE": "Máte <strong>{{dedicated}}</strong>GB cloudového úložiska",
      "SHARED_DEDICATED_DELETE": "Keď sa vaše úložisko zaplní, staré záznamy videohovorov budú odstránené",
      "SHARED_EXPIRE_TIME": "Vaše záznamy videohovorov budú uložené <strong>{{expire}}</strong> dní",
      "SHARED_EXPIRE_DELETE": "Po uplynutí tejto doby budú záznamy videohovorov vymazané",
      "SHARED_UNLIMITED": "Poskytujeme vám neobmedzenú úložnú kapacitu bez expirácie pre všetky vaše videozáznamy.",
      "PRIVATE_STORAGE_MESSAGE": "Účet Azure Cloud Storage môžete pripojiť k {{appName}}.",
      "PRIVATE_STORAGE_EXPLANATION": "Záznamy videohovorov sa nahrajú do vášho úložiska.",
      "PRIVATE_NO_AZURE": "NIE JE PRIPOJENÉ ŽIADNE ÚLOŽISKO AZURE CLOUD",
      "PRIVATE_AZURE": "AZURE CLOUD SKLADOVANIE PRIPOJENÉ",
      "PRIVATE_AZURE_NAME": "Názov účtu: {{account_name}}",
      "AZURE_INFO_LOADING": "Načítava",
      "CHECK_AZURE_TEMPLATE": {
        "CONNECT_AZURE_CLOUD_STORAGE": "Pripojte sa k službe Azure Cloud Storage",
        "DISCONNECT_AZURE_CLOUD_STORAGE": "Odpojte Azure Cloud Storage",
        "CAUTION": "UPOZORNENIE: Práve prebieha ukladanie záznamu videohovoru. Ak teraz zmeníte úložisko, môže dôjsť k strate záznamu.",
        "CANCEL": "Zrušiť",
        "CONNECT_ANYWAY": "Napriek tomu sa pripojiť",
        "DISCONNECT_ANYWAY": "Napriek tomu odpojiť"
      },
      "CONNECT_AZURE_TEMPLATE": {
        "CONNECT_AZURE_CLOUD_STORAGE": "Pripojte sa k službe Azure Cloud Storage",
        "ACCOUNT_NAME": "Názov účtu",
        "ACCOUNT_NAME_IS_REQUIRED": "Vyžaduje sa názov účtu.",
        "CONTAINER_NAME": "Názov kontajnera",
        "CONTAINER_NAME_IS_REQUIRED": "Vyžaduje sa názov kontajnera.",
        "ACCOUNT_KEY": "Kľúč účtu",
        "ACCOUNT_KEY_IS_REQUIRED": "Vyžaduje sa kľúč účtu.",
        "CANCEL": "Zrušiť",
        "CONNECT": "Pripojiť sa"
      },
      "DISCONNECT_AZURE_MODAL": {
        "TITLE": "Odpojiť Azure Cloud Storage",
        "MESSAGE": "Váš účet Azure bude odpojený.",
        "CAUTION": "UPOZORNENIE: Ak odpojíte tento účet, nebudete môcť stiahnuť záznamy, ktoré boli uložené v tomto účte Azure pomocou panela správcu {{appName}}.",
        "CANCEL": "Zrušiť",
        "DISCONNECT": "Odpojiť"
      },
      "ARCHIVE_STORAGE": {
        "ARCHIVE_UNAVAILABLE": "Záznam videohovoru: Vaša licencia túto funkciu neobsahuje.",
        "PRIVATE_STORAGE_UNAVAILABLE": "Vaša licencia neobsahuje funkciu Azure Integration."
      },
      "WEBDAV_MESSAGE": "Záznamy videohovorov budú nahrané na váš webdav účet."
    },
    "LICENCE-EXPIRED": "Platnosť vašej licencie vypršala"
  },
  "MODALS": {
    "ALERT": {
      "TEXT": "Ste si istý?",
      "CANCEL": "Zrušiť",
      "CONFIRM": "Odstrániť",
      "CONTINUE": "Pokračovať"
    },
    "IMAGE-EDITOR": {
      "TITLE": "Editor obrázkov",
      "CANCEL": "Zrušiť",
      "SAVE": "Uložiť",
      "CROP": "Orezať"
    },
    "TEMPLATE": {
      "CREATE-STEP": "Vytvoriť krok",
      "OPTIONS": {
        "TITLE": "Vyberte šablónu",
        "FULL": "Celá strana",
        "VERTICAL": "Vertikálna strana",
        "HORIZONTAL": "Horizontálna strana"
      },
      "CREATE": "Vytvoriť ",
      "CHANGE": "Zmeniť"
    },
    "WORKFLOW-USERS": {
      "TITLE": "Používatelia Workflow",
      "USERS": "Používatelia",
      "SELECTED": "Vybraní používatelia",
      "CLOSE": "Zavrieť",
      "SAVE": "Uložiť",
      "LIMIT-FULL": "Limit používateľov pracovného postupu je plný"
    },
    "GENERATE-WORKFLOW": {
      "TITLE": "Vytvorte automatický pracovný postup s AI",
      "PROMPT-TEXT": "Tu zadajte výzvu",
      "CONFIRM-BUTTON-TEXT": "PREDLOŽIŤ",
      "CANCEL-BUTTON-TEXT": "ZRUŠIŤ",
      "INVALID-WORKFLOW-ERROR": "Pracovný postup nemožno vytvoriť pomocou výzvy",
      "PERMISSION-DENIED": "Nemáte povolenie",
      "PROMPT-REQUIRED": "Text výzvy sa nenašiel",
      "INTERNAL-ERROR": "Nastala chyba"
    },
    "SIGNATURE": {
      "ADD-SIGNATURE": "Pridať podpis",
      "DRAW-SIGNATURE": "Nakreslite svoj podpis",
      "CLEAR": "Jasný",
      "REQUIRED-NAME": "Meno je povinné",
      "INSERT": "Vložiť",
      "TYPE-SIGNATURE": "Zadajte svoj podpis",
      "USE-PHOTO": "Použite fotografiu svojho podpisu"
    },
    "WORKFLOW-NEW-LANGUAGE": {
      "ADD-LANGUAGE": "Pridať jazyk",
      "NEW-LANGUAGE": "Chystáte sa pridať nový jazyk do pracovného postupu. Chcete automaticky preložiť všetok obsah z predvoleného jazyka do jazyka, ktorý pridávate? Ak chcete obsah preložiť sami, môžete skopírovať všetok predvolený obsah do nového jazyka a upraviť ho manuálne.",
      "AUTO-TRANSLATE": "Automatický preklad",
      "COPY-CONTENT": "Skopírujte obsah z predvoleného nastavenia"     
    },
    "DEFAULT-LANGUAGE": {
        "PRIMARY-LANGUAGE": "Jazyk, ktorý vyberiete ako predvolený, bude primárnym jazykom, v ktorom sa používateľom zobrazí tento pracovný postup na ich zariadeniach. Viacjazyčný pracovný postup môžete vytvoriť pridaním ďalších jazykov do editora po vytvorení pracovného postupu.",
        "DEFAULT-LANGUAGE": "Predvolený jazyk tohto pracovného postupu",
        "CREATE": "VYTVORIŤ"
    },
    "USER-DEFAULT-LANGUAGE": {
      "PREFFERED-LANGUAGE": "Vyberte preferovaný jazyk, v ktorom chcete zobraziť obsah pracovných postupov."
    },
    "TABLE-CELL": {
        "AT-LEAST": "Toto pole by malo byť aspoň {{selectedCell.templateOptions.min}}",
        "AT-MOST": "Toto pole by malo byť najviac {{selectedCell.templateOptions.max}}"
    },
    "OPEN-AI": {
        "DESCRIBE": "Popíšte pracovný postup, ktorý chcete vytvoriť"
    }
  },
  "NOT-FOUND": {
    "TEXT": "Ľutujeme, požadovaná stránka sa nenašla.",
    "INFORM": "Adresa URL môže byť nesprávne napísaná alebo stránka, ktorú hľadáte, už nie je dostupná."
  },
  "ERRORS": {
    "UPLOAD-ERROR": "Chyba nahrávania",
    "ERROR": "Vyskytla sa chyba"
  },
  "WEB-VERSION": {
    "TASK-TO-COMPLETE": "Úloha na dokončenie",
    "ESTIMATED-DURATION": "Odhadované trvanie",
    "START": "ŠTART",
    "PREVIOUS": "Predchádzajúci",
    "NEXT": "Ďalší",
    "SUBMIT": "Odoslať",
    "SUCCESS-SUBMIT-MESSAGE": "Váš pracovný postup bol úspešne odoslaný!",
    "SUCCESS-SAVE-MESSAGE": "Váš pracovný postup bol úspešne uložený!",
    "SAVE-AS-DRAFT": "Uložiť ako koncept",
    "CLOSE-WORKFLOW-WARNING-TEXT": "Naozaj chcete zatvoriť tento pracovný postup? Vaše zmeny budú odstránené.",
    "CONTINUE-WORKFLOW-TEXT-MESSAGE": "Tento pracovný postup ste už začali. Chcete pokračovať, alebo začať nový?",
    "CONTINUE": "Pokračovať",
    "START-OVER": "ZAČAŤ ODZNOVA",
    "INCOMPLETE": "Neúplné",
    "SUBMITTED": "Odoslané",
    "VERSION": "Verzia",
    "LAST-SAVED": "Naposledy uložené",
    "PUBLISHED-AT": "Zverejnené o",
    "STATUS": "Status",
    "SELECT": "Vybrať",
    "SEARCH": "Vyhľadávanie"
  },
  "Number": "Číslo",
  "Text": "Text",
  "Multiple Choice": "Viacero možností",
  "Checkboxes": "Začiarkavacie políčka",
  "Date": "Dátum",
  "Time": "Čas",
  "File Upload": "Nahranie súboru",
  "Capture Image": "Zachytiť obrázok",
  "Capture Video": "Zaznamenať video",
  "PPE": "OOP",
  "QR": "QR",
  "Contains": "Obsahuje",
  "Does not contain": "Neobsahuje",
  "Is empty": "Je prázdny",
  "Is not empty": "Nie je prázdny",
  "Equals": "Rovná sa",
  "Not Equals": "Nerovná sa",
  "Greater than": "Väčší než",
  "Less than": "Menší než",
  "Greater or Equal": "Väčší alebo Rovný",
  "Less or Equal": "Menší alebo Rovný",
  "Is": "Je",
  "Is not": "Nie je",
  "Starts with": "Začína s",
  "Ends with": "Končí s",
  "Is before": "Je predt",
  "Is after": "Je po",
  "Is between": "Je medzi",
  "Is not between": "Nie je medzi",
  "Is detected": "Je zistený",
  "Is not detected": "Nie je zistený",
  "input": "Textový vstup",
  "number": "Zadanie čísla",
  "datepicker": "Výběr dátumu",
  "multicheckbox": "Zaškrtávací políčko",
  "radio": "Tlačítko Rádio",
    "PAGINATOR": {
        "ITEMS_PER_PAGE": "Položiek na stranu:",
        "NEXT_PAGE": "Ďalšia strana",
        "PREVIOUS_PAGE": "Predchádzajúca strana",
        "FIRST_PAGE": "Prvá strana",
        "LAST_PAGE": "Posledná strana",
        "RANGE": "{{start}} – {{end}} z {{length}}",
        "RANGE_ZERO": "0 z {{length}}"
    }
}